// import React, { useState, useEffect } from 'react';
// import { Modal, Button, Form, Row, Col, Offcanvas,Table } from 'react-bootstrap';
// import axios from 'axios';
// import { useNavigate, useLocation } from 'react-router-dom';
// import ReactQuill from 'react-quill';
// import 'react-quill/dist/quill.snow.css';
// import Swal from 'sweetalert2';

// const PurchaseOrderForm = ({ showModal, vendorId, onUpdate, products, handleClose, fetchQuotations, isQuotationParent, setPurchaseOrder, setPurchaseOrders, projectId, vendors, poId, quotationId, purchaseorderData }) => {
//     console.log('po:', purchaseorderData);
//     const quotation_id = purchaseorderData ? purchaseorderData.quotation_id : '';  // Use a default value if null or undefined
//     const navigate = useNavigate();
//     const [purchaseOrderDetails, setPurchaseOrderDetails] = useState([products || []]);


//     const [refNo, setRefNo] = useState('');

//     const [formData, setFormData] = useState({
//         project_id: projectId,
//         quotation_id: quotationId,
//         vendor_id: vendorId,
//         ref_no: '',
//         date: '',
//         valid_till_date: '',
//         document: '',
//         discount_amount: '',
//         discount_type: 'amount',
//         serial_no: '',
//         amount: '',
//         notes: '',
//         purchase_type: '',
//         payment_term: '',
//         start_date: '',
//         end_date: '',
//         due_date: '',
//     });

//     const [selectedProducts, setSelectedProducts] = useState([]);
//     const [totalAmount, setTotalAmount] = useState(0);
//     const [discountedAmount, setDiscountedAmount] = useState(0);
// const location = useLocation();
// const isPOListPage = location.pathname === "/po-list";

// const [manualItems, setManualItems] = useState([
//     { item_name: "", item_description: "", quantity: 1, price: 0, vat: 0, subtotal: 0 }
// ]);
// const vendorCurrency = vendors[Number(vendorId)] || "AED";
// const calculateVAT = (price, qty) => {
//     if (vendors[Number(vendorId)] === "USD") return 0; // No VAT for USD
//     return (price * qty) * 0.05; // 5% VAT for AED
// };
// const updateManualItem = (index, field, value) => {
//     const updated = [...manualItems];
//     updated[index][field] = value;

//     const price = parseFloat(updated[index].price) || 0;
//     const qty = parseFloat(updated[index].quantity) || 1;

//     updated[index].vat = calculateVAT(price, qty);
//     updated[index].subtotal = (price * qty) + updated[index].vat;

//     setManualItems(updated);
// };
// const addManualRow = () => {
//     setManualItems([
//         ...manualItems,
//         { item_name: "", item_description: "", quantity: 1, price: 0, vat: 0, subtotal: 0 }
//     ]);
// };

//     useEffect(() => {
//         if (!products || products.length === 0) {
//             return;
//         }

//         const vendorCurrency = vendors[Number(vendorId)] || 'AED';
//         console.log('currency:', vendorCurrency);
//         // Adjust product prices based on vendor's currency
//         const adjustedProducts = products.map(product => {
//             const priceInVendorCurrency = product.product.purchase_price;
//             const priceInUSD = vendorCurrency === 'USD'
//                 ? priceInVendorCurrency / 3.67  // Convert AED to USD (adjust the rate if necessary)
//                 : priceInVendorCurrency; // Use AED if the currency is AED
//             console.log('priceinusd:', priceInUSD);
//             return { ...product, priceInVendorCurrency, priceInUSD };
//         });


//         const filteredProducts = adjustedProducts.filter(product =>
//             product.itemable_id === quotationId && product.product.vendor_id === vendorId
//         );



//         console.log("Filtered Products:", filteredProducts);
//         setSelectedProducts(filteredProducts);
//     }, [products, quotationId, vendorId]);

//     // Automatically set due date = 3 days before end_date
// useEffect(() => {
//   if (formData.end_date) {
//     const endDate = new Date(formData.end_date);
//     const dueDate = new Date(endDate);
//     dueDate.setDate(endDate.getDate() - 30); // subtract 3 days

//     const formattedDueDate = dueDate.toISOString().split("T")[0];

//     setFormData((prev) => ({
//       ...prev,
//       due_date: formattedDueDate,
//     }));
//   }
// }, [formData.end_date]);


//     const fetchTermsDetails = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/quotationterm`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`, 'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,

//             });

//             // Filter the data for type 'quotation' and set 'value' field as notes
//             const termDetails = response.data.quotation_terms.data.filter(term => term.type === 'purchase_order');

//             if (termDetails.length > 0) {
//                 let notes = termDetails[0]?.value || ''; // Assuming there's at least one term of type 'quotation'

//                 const vendorCurrency = vendors[Number(vendorId)] || 'AED';
//                 if (vendorCurrency) {
//                     notes = notes.replace(/{{currency}}/g, vendorCurrency); // Replace with the client's currency
//                 }

//                 setFormData((prevState) => ({
//                     ...prevState,
//                     notes: notes, // Set fetched notes to formData.notes
//                 }));
//             }

//         } catch (error) {
//             console.error('Error fetching quotation terms:', error);
//         }
//     };


//     useEffect(() => {
//         if (showModal && !poId) {
//             // Fetch terms only when creating a new quotation
//             fetchTermsDetails();
//         } else if (showModal && poId && purchaseorderData) {
//             // If editing, use the existing quotation's notes
//             setFormData({
//                 ...purchaseorderData,
//                 notes: purchaseorderData.notes || formData.notes, // Ensure notes is set correctly
//             });
//         }
//     }, [showModal, poId, purchaseorderData, vendors, vendorId]);



//     const handleEditorChange = (value) => {
//         setFormData({
//             ...formData,
//             notes: value, // Save the content from React Quill to the notes field
//         });
//     };


//     useEffect(() => {
//         if (poId && purchaseorderData) {
//             const subscription = purchaseorderData.vendor_subscriptions?.[0] || {};
//             setFormData({
//                 project_id: purchaseorderData.project_id || '',
//                 quotation_id: purchaseorderData.quotation_id || '',
//                 vendor_id: purchaseorderData.vendor_id || '',
//                 ref_no: purchaseorderData.ref_no || '',
//                 date: purchaseorderData.date || '',
//                 valid_till_date: purchaseorderData.valid_till_date || '',
//                 document: purchaseorderData.document || '',
//                 discount_amount: purchaseorderData.discount_amount || '',
//                 discount_type: purchaseorderData.discount_type || 'amount',
//                 serial_no: purchaseorderData.serial_no || '',
//                 amount: purchaseorderData.amount || '',
//                 notes: purchaseorderData.notes || '',
//                 purchase_type: purchaseorderData.purchase_type || '',
//                 payment_term: subscription.payment_term || '',
//                 start_date: subscription.start_date || '',
//                 end_date: subscription.end_date || '',
//                 due_date: JSON.parse(subscription.due_dates || '[]')[0]?.date || '',

//             });

//             // Adjust products and log them for debugging
//             const adjustedProducts = (purchaseorderData.product_item_details || []).map(product => {
//                 const price = parseFloat(product.price) || 0;
//                 const exchangeRate = parseFloat(product.exchange_rate) || 1; // Default to 1 if exchange_rate is missing
//                 const priceInUSD = product.currency === 'USD' ? price : price / exchangeRate; // Convert price to USD if not in USD
//                 const quantity = product.quantity || 1;
//                 const subtotal = quantity * priceInUSD;

//                 // Log adjusted product details
//                 console.log("Adjusted Product:", { ...product, priceInUSD, subtotal });

//                 return {
//                     ...product,
//                     priceInUSD,
//                     subtotal,
//                 };
//             });


//             setSelectedProducts(adjustedProducts);
//             setTotalAmount(
//                 adjustedProducts.reduce((total, product) => total + product.subtotal, 0)
//             );
//         } else {
//             const currentDate = new Date().toISOString().split('T')[0];
//             setFormData({
//                 project_id: projectId,
//                 quotation_id: quotationId,
//                 vendor_id: vendorId,
//                 ref_no: '',
//                 date: currentDate,
//                 valid_till_date: '',
//                 document: '',
//                 discount_amount: '',
//                 discount_type: 'amount',
//                 serial_no: '',
//                 amount: '',
//             });
//         }
//     }, [poId, purchaseorderData, vendorId, quotationId, projectId]);


//     useEffect(() => {
//         if (showModal) {
//             // Only fetch the generated ref_no if we are creating a new purchase order
//             if (!poId) {  // When poId is null or undefined (create mode)
//                 const fetchRefNo = async () => {
//                     try {
//                         const backendUrl = process.env.REACT_APP_BACKEND_URL;
//                         const userInfo = JSON.parse(localStorage.getItem('user-info'));
//                         const origin = localStorage.getItem('user-origin');
//                         const token = userInfo?.token;

//                         const response = await axios.get(`${backendUrl}/api/purchaseorder/ref-no`, {
//                             headers: {
//                                 'Authorization': `Bearer ${token}`,
//                                 'Tenant-Origin': origin,

//                             },
//                             skipLoader: true,

//                             params: {
//                                 quotation_id: quotationId, // Pass the quotation ID to generate the ref_no
//                             }
//                         });

//                         setRefNo(response.data.ref_no);
//                         setFormData(prevData => ({
//                             ...prevData,
//                             ref_no: response.data.ref_no, // Update formData with the fetched ref_no
//                         }));
//                     } catch (error) {
//                         console.error('Error fetching ref_no:', error);
//                     }
//                 };
//                 fetchRefNo();
//             } else {
//                 // If editing, you can use the existing ref_no or any other logic
//                 console.log('Editing existing purchase order, no need to fetch new ref_no');
//             }
//         }
//     }, [showModal, quotationId, poId]); // Make sure poId and quotationId are included as dependencies

//     useEffect(() => {
//         // Calculate total amount when selected products change
//         const total = selectedProducts.reduce((acc, product) => acc + (product.priceInUSD * product.quantity), 0);
//         setTotalAmount(total);
//     }, [selectedProducts]);

//     const calculateDiscountedTotal = () => {
//         const { discount_type, discount_amount } = formData;
//         let discountedTotal = totalAmount;

//         if (discount_type === 'amount') {
//             discountedTotal -= parseFloat(discount_amount || 0); // Apply amount discount
//         } else if (discount_type === 'percentage') {
//             const discountValue = (parseFloat(discount_amount || 0) / 100) * totalAmount;
//             discountedTotal -= discountValue;
//         }

//         return Math.max(0, discountedTotal); // Ensure it doesn't go below 0
//     };

//     useEffect(() => {
//         // Recalculate the discounted total whenever totalAmount, discount_amount, or discount_type changes
//         setDiscountedAmount(calculateDiscountedTotal());
//     }, [formData.discount_amount, formData.discount_type, totalAmount]);


//     const handleQuantityChange = (e, productId) => {
//         const newQuantity = parseInt(e.target.value, 10);
//         const updatedProducts = selectedProducts.map(product =>
//             product.id === productId ? { ...product, quantity: newQuantity, subtotal: newQuantity * product.price } : product
//         );
//         setSelectedProducts(updatedProducts);
//     };

//     const handleDeleteProduct = (productId) => {
//         const updatedProducts = selectedProducts.filter(product => product.id !== productId);
//         setSelectedProducts(updatedProducts);
//     };

//     const addPO = async (newPO) => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.post(`${backendUrl}/api/purchase-order`, newPO, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Content-Type': 'multipart/form-data',
//                     'Tenant-Origin': origin,

//                 },
//             });

//             const createdPurchseorder = response.data.purchaseorder;

//             setPurchaseOrderDetails((prevPurchaseorder = []) => [...prevPurchaseorder, createdPurchseorder]);

//             navigate(`/purchase-order/details/${createdPurchseorder.id}`);

//             handleClose();
//         } catch (error) {
//             console.error('Error adding quotation:', error);
//         }
//     };

//     const editPO = async (poId, updatedData) => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem("user-origin");
//             const token = userInfo?.token;

//             const response = await axios.post(
//                 `${backendUrl}/api/purchase-order/${poId}?_method=PUT`,
//                 updatedData,
//                 {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                         "Content-Type": "multipart/form-data",
//                         'Tenant-Origin': origin,

//                     },
//                 }
//             );

//             const updatedPO = response.data?.purchaseorder;

//             if (updatedPO) {
//                 console.log("Purchase Order updated successfully:", updatedPO);

//                 // Check which `setPurchaseOrder` or `setPurchaseOrders` function is passed and update accordingly
//                 if (setPurchaseOrder) {
//                     // If setPurchaseOrder is passed (likely for a single purchase order update)
//                     setPurchaseOrder((prevPO) => ({
//                         ...prevPO,
//                         ...updatedPO,
//                         product_item_details: updatedPO.product_item_details.map((newItem, index) => {
//                             const existingItem = prevPO.product_item_details?.[index] || {};
//                             return {
//                                 ...existingItem,
//                                 ...newItem,
//                                 product: {
//                                     ...existingItem.product,
//                                     ...newItem.product,
//                                     vendor: {
//                                         ...existingItem.product?.vendor,
//                                         ...newItem.product?.vendor,
//                                     },
//                                 },
//                             };
//                         }),
//                     }));
//                 } else if (setPurchaseOrders) {
//                     // If setPurchaseOrders is passed (likely for updating the list of purchase orders)
//                     setPurchaseOrders((prevOrders) => {
//                         const ordersArray = Array.isArray(prevOrders) ? prevOrders : [];  // Ensure it's an array
//                         return ordersArray.map((po) =>
//                             po.id === poId ? updatedPO : po
//                         );
//                     });
//                 }

//             } else {
//                 console.error("Update failed, no data returned from API.");
//             }

//             handleClose();  // Close the modal
//         } catch (error) {
//             console.error("Error updating purchase order:", error);
//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'error',
//                 title: 'Failed to update the purchase order. Please try again.',
//                 timer: 3000,
//                 timerProgressBar: false,
//                 showConfirmButton: false,
//                 didOpen: () => {
//                     const container = Swal.getContainer();
//                     container.style.top = '50px';
//                 },
//             });
//         }
//     };

//     const [loading, setLoading] = useState(false);

//     const handleSubmit = async (e) => {
//         e.preventDefault();



//         const purchaseOrderData = {
//             ...formData,
//             amount: discountedAmount,
//             vendorId,
//             quotationId,
//             products: selectedProducts.map(product => ({
//                 product_id: product.product?.id,
//                 quantity: product.quantity,
//                 price: product.priceInUSD,
//                 subtotal: product.quantity * product.priceInUSD,
//                 item_name: product.item_name,
//                 item_description: product.item_description,
//             })),
//         };
//         console.log('Selected Products:', selectedProducts);

//         setLoading(true);  // Start loading

//         try {
//             let response;

//             if (poId) {
//                 response = await editPO(poId, purchaseOrderData);
//                 if (isQuotationParent) {
//                     // updateQuotationState(response, quotationId);
//                     fetchQuotations();
//                 }
//                 Swal.fire({
//                     toast: true,
//                     position: 'top-end',
//                     icon: 'success',
//                     title: 'Purchase order updated successfully.',
//                     timer: 3000,
//                     timerProgressBar: false,
//                     showConfirmButton: false,
//                     didOpen: () => {
//                         const container = Swal.getContainer();
//                         container.style.top = '50px';
//                     },
//                 });
//             } else {
//                 response = await addPO(purchaseOrderData);
//             }

//         } catch (error) {
//             console.error('Error submitting the form:', error);
//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'error',
//                 title: 'There was an error processing your request.',
//                 timer: 3000,
//                 timerProgressBar: false,
//                 showConfirmButton: false,
//                 didOpen: () => {
//                     const container = Swal.getContainer();
//                     container.style.top = '50px';
//                 },
//             });
//         } finally {
//             setLoading(false);  // Stop loading
//             handleClose();
//         }
//     };




//     return (
//         <Offcanvas show={showModal} onHide={handleClose} placement='end' style={{ zIndex: 1050, width: '900px' }}>
//             <Offcanvas.Header closeButton>
//                 <Offcanvas.Title>{poId ? 'Edit Purchase Order' : 'Create Purchase Order'}</Offcanvas.Title>
//             </Offcanvas.Header>
//             <hr style={{ margin: 0 }} /><br />

//             <Offcanvas.Body>
//                 <Form onSubmit={handleSubmit}>
//                     <Row className="mb-3">
//                         <Col md={6}>
//                             <Form.Group controlId="ref_no">
//                                 <Form.Label style={{ fontSize: "13px" }}>Reference Number</Form.Label>
//                                 <Form.Control
//                                     style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                     type="text"
//                                     name="ref_no"
//                                     value={formData.ref_no}
//                                     // value={refNo}
//                                     readOnly
//                                 />
//                             </Form.Group>
//                         </Col>
//                         <Col md={6}>
//                             <Form.Group controlId="date">
//                                 <Form.Label style={{ fontSize: "13px" }}>Date</Form.Label>
//                                 <Form.Control
//                                     style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                     type="date"
//                                     name="date"
//                                     value={formData.date}
//                                     onChange={(e) => setFormData({ ...formData, date: e.target.value })}
//                                 />
//                             </Form.Group>
//                         </Col>
//                     </Row>

//                     <Row className="mb-3">
//                         <Col md={6}>
//                             <Form.Group controlId="valid_till_date">
//                                 <Form.Label style={{ fontSize: "13px" }}>Valid Till Date</Form.Label>
//                                 <Form.Control
//                                     style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                     type="date"
//                                     name="valid_till_date"
//                                     value={formData.valid_till_date}
//                                     onChange={(e) => setFormData({ ...formData, valid_till_date: e.target.value })}
//                                 />
//                             </Form.Group>
//                         </Col>
//                         <Col md={6}>
//                             <Form.Group controlId="document">
//                                 <Form.Label style={{ fontSize: "13px" }}>Document</Form.Label>
//                                 <Form.Control
//                                     style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                     type="file"
//                                     name="document"
//                                     onChange={(e) => setFormData({ ...formData, document: e.target.files[0] })}
//                                 />
//                             </Form.Group>
//                         </Col>
//                     </Row>

//                     <Row className="mb-3">
//                         <Col md={6}>
//                             <Form.Group controlId="discount_amount">
//                                 <Form.Label style={{ fontSize: "13px" }}>One Time Discount</Form.Label>
//                                 <Form.Control
//                                     style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                     type="text"
//                                     name="discount_amount"
//                                     value={formData.discount_amount}
//                                     onChange={(e) => setFormData({ ...formData, discount_amount: e.target.value })}
//                                 />
//                             </Form.Group>
//                         </Col>
//                         <Col md={6}>
//                             <Form.Group controlId="discount_type">
//                                 <Form.Label style={{ fontSize: "13px" }}>Discount Type</Form.Label>
//                                 <Form.Select
//                                     style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                     name="discount_type"
//                                     value={formData.discount_type}
//                                     onChange={(e) => setFormData({ ...formData, discount_type: e.target.value })}
//                                 >
//                                     <option value="amount">Amount</option>
//                                     <option value="percentage">Percentage</option>
//                                 </Form.Select>
//                             </Form.Group>
//                         </Col>
//                     </Row>
//                     <Row className="mb-3">
//                         <Col md={6}>
//                             <Form.Group>
//                                 <Form.Label style={{ fontSize: "13px" }}>Purchase Type</Form.Label>
//                                 <Form.Select
//                                     style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                     value={formData.purchase_type || ''}
//                                     onChange={(e) => setFormData({ ...formData, purchase_type: e.target.value })}
//                                 >
//                                     <option value="">-- Select --</option>
//                                     <option value="product">Product</option>
//                                     <option value="subscription">Subscription</option>
//                                 </Form.Select>
//                             </Form.Group>
//                         </Col>

//                         {formData.purchase_type === 'subscription' && (
//                             <>
//                                 <Col md={6}>
//                                     <Form.Group>
//                                         <Form.Label style={{ fontSize: "13px" }}>Payment Term</Form.Label>
//                                         <Form.Select
//                                             style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                             value={formData.payment_term || ''}
//                                             onChange={(e) => setFormData({ ...formData, payment_term: e.target.value })}
//                                         >
//                                             <option value="">-- Select Term --</option>
//                                             <option value="yearly">Yearly</option>
//                                             <option value="half-yearly">Half-Yearly</option>
//                                             <option value="quarterly">Quarterly</option>
//                                             <option value="custom">Manual</option>
//                                         </Form.Select>
//                                     </Form.Group>
//                                 </Col>

//                                 <Col md={6}>
//                                     <Form.Group>
//                                         <Form.Label style={{ fontSize: "13px" }}>Start Date</Form.Label>
//                                         <Form.Control
//                                             style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                             type="date"
//                                             value={formData.start_date || ''}
//                                             onChange={(e) => setFormData({ ...formData, start_date: e.target.value })}
//                                         />
//                                     </Form.Group>
//                                 </Col>

//                                 <Col md={6}>
//                                     <Form.Group>
//                                         <Form.Label style={{ fontSize: "13px" }}>End Date</Form.Label>
//                                         <Form.Control
//                                             style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                             type="date"
//                                             value={formData.end_date || ''}
//                                             onChange={(e) => setFormData({ ...formData, end_date: e.target.value })}
//                                         />
//                                     </Form.Group>
//                                 </Col>

//                                 {/* {formData.payment_term === 'custom' && ( */}
//                                 <Col md={6}>
//                                     <Form.Group>
//                                         <Form.Label style={{ fontSize: "13px" }}>Due Date</Form.Label>
//                                         <Form.Control
//                                             style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                             type="date"
//                                             value={formData.due_date || ''}
//                                             onChange={(e) => setFormData({ ...formData, due_date: e.target.value })}
//                                         />
//                                     </Form.Group>
//                                 </Col>
//                                 {/* )} */}
//                             </>
//                         )}
//                     </Row>

//                     <br /><br />

//                     <div>
//                         <table className="table">
//                             <thead>
//                                 <tr>
//                                     <th width="20%" scope="col">Product</th>
//                                     <th width="30%" scope="col">Description</th>
//                                     <th width="10%" scope="col">Rate</th>
//                                     <th width="10%" scope="col">Qty</th>
//                                     <th width="10%" scope="col">SubTotal</th>
//                                     <th width="10%" scope="col">Action</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {selectedProducts.map(product => (
//                                     <tr key={product.id}>
//                                         <td>{product.item_name}</td>
//                                         <td>{product.item_description}</td>
//                                         <td>{(Number(product.priceInUSD) && !isNaN(Number(product.priceInUSD)) ? Number(product.priceInUSD) : 0).toFixed(2)}</td>
//                                         <td>
//                                             <input
//                                                 type="number"
//                                                 value={product.quantity}
//                                                 min="1"
//                                                 className='form-control'
//                                                 onChange={(e) => handleQuantityChange(e, product.id)}
//                                             />
//                                         </td>
//                                         <td>{(product.quantity * (Number(product.priceInUSD) || 0)).toFixed(2)}</td>
//                                         <td>
//                                             <span
//                                                 style={{ cursor: 'pointer', color: 'grey' }}
//                                                 onClick={() => handleDeleteProduct(product.id)}
//                                             >
//                                                 <i className="fa fa-trash"></i>
//                                             </span>
//                                         </td>
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>
//                     </div>
//                     {isPOListPage && (
//     <>
//         <h6>Manual Line Items</h6>
//         <Table bordered>
//             <thead>
//                 <tr>
//                     <th>Name</th>
//                     <th>Description</th>
//                     <th>Qty</th>
//                     <th>Price</th>
//                     <th>VAT</th>
//                     <th>Subtotal</th>
//                 </tr>
//             </thead>
//             <tbody>
//                 {manualItems.map((item, i) => (
//                     <tr key={i}>
//                         <td>
//                             <Form.Control
//                                 value={item.item_name}
//                                 onChange={(e) => updateManualItem(i, "item_name", e.target.value)}
//                             />
//                         </td>
//                         <td>
//                             <Form.Control
//                                 value={item.item_description}
//                                 onChange={(e) => updateManualItem(i, "item_description", e.target.value)}
//                             />
//                         </td>
//                         <td>
//                             <Form.Control
//                                 type="number"
//                                 value={item.quantity}
//                                 onChange={(e) => updateManualItem(i, "quantity", e.target.value)}
//                             />
//                         </td>
//                         <td>
//                             <Form.Control
//                                 type="number"
//                                 value={item.price}
//                                 onChange={(e) => updateManualItem(i, "price", e.target.value)}
//                             />
//                         </td>
//                         <td>{item.vat.toFixed(2)}</td>
//                         <td>{item.subtotal.toFixed(2)}</td>
//                     </tr>
//                 ))}
//             </tbody>
//         </Table>

//         <Button size="sm" onClick={addManualRow}>+ Add Item</Button>
//     </>
// )}

//                     <br /><br />

//                     {formData.discount_amount > 0 && (
//                         <Row className="mb-3">
//                             <Col md={9}></Col>
//                             <Col md={3}>
//                                 <label className="font_13 theme_text f_w_500 mb-0" htmlFor="discountAmount">
//                                     Discount ({formData.discount_type === 'percentage' ? `${formData.discount_amount}%` : ''})
//                                 </label>
//                                 <div className="primary_input grid_input calculated_total text-end">
//                                     <input
//                                         type="text"
//                                         className="form-control"
//                                         value={formData.discount_type === 'percentage'
//                                             ? ((totalAmount * parseFloat(formData.discount_amount || 0)) / 100).toFixed(2)
//                                             : parseFloat(formData.discount_amount || 0).toFixed(2)}
//                                         name="discount_amount"
//                                         readOnly
//                                     />
//                                 </div>
//                             </Col>
//                         </Row>
//                     )}

//                     <Row className="mb-3">
//                         <Col md={9}></Col>
//                         <Col md={3}>
//                             <label className="font_13 theme_text f_w_500 mb-0" htmlFor="totalAmount">Total Amount</label>
//                             <div className="primary_input grid_input calculated_total text-end">
//                                 <input
//                                     type="text"
//                                     className="form-control"
//                                     value={discountedAmount.toFixed(2)}
//                                     name="amount"
//                                     readOnly
//                                 />
//                             </div>
//                         </Col>
//                     </Row>
//                     <Row className="mb-3">
//                         <Col md={12}>
//                             <Form.Group controlId="notes">
//                                 <Form.Label style={{ fontSize: "13px" }}>Payment Terms</Form.Label>
//                                 <ReactQuill
//                                     value={formData.notes}
//                                     onChange={handleEditorChange} // Bind the editor value to the notes field
//                                     theme="snow"
//                                 // style={{ height: '100px' }}
//                                 />
//                             </Form.Group>
//                         </Col>
//                     </Row>
//                 </Form>
//             </Offcanvas.Body>
//             <div className="p-3 d-flex justify-content-end border-top">
//                 <button type="button" className="btn btn-secondary me-2" onClick={handleClose}>
//                     Close
//                 </button>
//                 <button type="button" className="btn btn-primary" onClick={handleSubmit}>
//                     Save
//                 </button>
//             </div>
//         </Offcanvas>
//     );
// };

// export default PurchaseOrderForm;

// import React, { useState, useEffect } from 'react';
// import { Modal, Button, Form, Row, Col, Offcanvas, Table } from 'react-bootstrap';
// import axios from 'axios';
// import { useNavigate, useLocation } from 'react-router-dom';
// import ReactQuill from 'react-quill';
// import 'react-quill/dist/quill.snow.css';
// import Swal from 'sweetalert2';

// const PurchaseOrderForm = ({ showModal, vendorId, onUpdate, products, handleClose, fetchQuotations, isQuotationParent, setPurchaseOrder, setPurchaseOrders, projectId, vendors, poId, quotationId, purchaseorderData }) => {
//     console.log('po:', purchaseorderData);
//     console.log('vendorid:', vendors);
//     const quotation_id = purchaseorderData ? purchaseorderData.quotation_id : '';
//     const navigate = useNavigate();
//     const location = useLocation();
//     const isPOListPage = location.pathname === "/po-list";

//     const [purchaseOrderDetails, setPurchaseOrderDetails] = useState([products || []]);
//     const [refNo, setRefNo] = useState('');
//     const [selectedVendorId, setSelectedVendorId] = useState(vendorId || '');
//     const [vendorCurrency, setVendorCurrency] = useState('AED');
//     const [vatRate, setVatRate] = useState(0);

//     // Manual line items state - only for PO list page
//     const [manualItems, setManualItems] = useState([
//         { item_name: "", item_description: "", quantity: 1, price: 0, base_amount: 0, vat_amount: 0, subtotal: 0 }
//     ]);

//     const [formData, setFormData] = useState({
//         project_id: projectId,
//         quotation_id: quotationId,
//         vendor_id: selectedVendorId,
//         ref_no: '',
//         date: '',
//         valid_till_date: '',
//         document: '',
//         discount_amount: '',
//         discount_type: 'amount',
//         serial_no: '',
//         amount: '',
//         notes: '',
//         purchase_type: '',
//         payment_term: '',
//         start_date: '',
//         end_date: '',
//         due_date: '',
//     });

//     const [selectedProducts, setSelectedProducts] = useState([]);
//     const [totalBaseAmount, setTotalBaseAmount] = useState(0);
//     const [discountedAmount, setDiscountedAmount] = useState(0);
//     const [totalVatAmount, setTotalVatAmount] = useState(0);
//     const [finalAmount, setFinalAmount] = useState(0);
//     const [loading, setLoading] = useState(false);

//     // Reset form when modal closes
//     useEffect(() => {
//         if (!showModal) {
//             setSelectedVendorId(vendorId || '');
//             setVendorCurrency('AED');
//             setVatRate(0);
//             setManualItems([
//                 { item_name: "", item_description: "", quantity: 1, price: 0, base_amount: 0, vat_amount: 0, subtotal: 0 }
//             ]);
//             setFormData({
//                 project_id: projectId,
//                 quotation_id: quotationId,
//                 vendor_id: vendorId || '',
//                 ref_no: '',
//                 date: new Date().toISOString().split('T')[0],
//                 valid_till_date: '',
//                 document: '',
//                 discount_amount: '',
//                 discount_type: 'amount',
//                 serial_no: '',
//                 amount: '',
//                 notes: '',
//                 purchase_type: '',
//                 payment_term: '',
//                 start_date: '',
//                 end_date: '',
//                 due_date: '',
//             });
//             setSelectedProducts([]);
//             setTotalBaseAmount(0);
//             setDiscountedAmount(0);
//             setTotalVatAmount(0);
//             setFinalAmount(0);
//             setLoading(false);
//         }
//     }, [showModal, projectId, quotationId, vendorId]);

//     // Update vendor currency and VAT when vendor changes
//     useEffect(() => {
//         if (selectedVendorId && vendors && Array.isArray(vendors)) {
//             const selectedVendor = vendors.find(vendor => vendor.id == selectedVendorId);
//             if (selectedVendor) {
//                 const currency = selectedVendor.currency || 'AED';
//                 setVendorCurrency(currency);
//                 const vat = currency === 'USD' ? 0 : 5;
//                 setVatRate(vat);
//                 setFormData(prev => ({
//                     ...prev,
//                     vendor_id: selectedVendorId
//                 }));
//             }
//         }
//     }, [selectedVendorId, vendors]);

//     // Calculate VAT for manual items
//     const calculateItemVAT = (price, qty) => {
//         if (vendorCurrency === "USD") return 0;
//         return (price * qty) * (vatRate / 100);
//     };

//     // Calculate base amount (without VAT)
//     const calculateBaseAmount = (price, qty) => {
//         return price * qty;
//     };

//     // Update manual line item
//     // Update manual line item function
//     const updateManualItem = (index, field, value) => {
//         const updated = [...manualItems];
//         updated[index][field] = value;

//         const price = parseFloat(updated[index].price) || 0;
//         const qty = parseFloat(updated[index].quantity) || 1;
//         const taxRate = parseFloat(updated[index].tax) || 0;

//         updated[index].base_amount = calculateBaseAmount(price, qty);
//         updated[index].vat_amount = calculateItemVAT(price, qty, taxRate);
//         updated[index].subtotal = updated[index].base_amount + updated[index].vat_amount;

//         setManualItems(updated);
//     };




//     // Add new manual line item
//     const addManualRow = () => {
//         setManualItems([
//             ...manualItems,
//             { item_name: "", item_description: "", quantity: 1, price: 0, base_amount: 0, vat_amount: 0, subtotal: 0 }
//         ]);
//     };

//     // Calculate totals from manual items
//     const calculateManualItemsTotals = () => {
//         const baseTotal = manualItems.reduce((total, item) => total + item.base_amount, 0);
//         const vatTotal = manualItems.reduce((total, item) => total + item.vat_amount, 0);
//         return { baseTotal, vatTotal };
//     };

//     // FIXED: Load products for both create and edit modes
//     // useEffect(() => {
//     //     if (!products || products.length === 0) {
//     //         return;
//     //     }

//     //     // For editing existing PO, use the products from purchaseorderData
//     //     if (poId && purchaseorderData && purchaseorderData.product_item_details) {
//     //         const adjustedProducts = purchaseorderData.product_item_details.map(product => {
//     //             const price = parseFloat(product.price) || 0;
//     //             const quantity = product.quantity || 1;
//     //             const base_amount = price * quantity;
//     //             const vat_amount = vendorCurrency === 'USD' ? 0 : (base_amount * (vatRate / 100));

//     //             return {
//     //                 ...product,
//     //                 priceInUSD: price,
//     //                 base_amount,
//     //                 vat_amount,
//     //                 subtotal: base_amount + vat_amount
//     //             };
//     //         });
//     //         setSelectedProducts(adjustedProducts);
//     //         return;
//     //     }

//     //     // For creating new PO, filter products based on vendor and quotation
//     //     const adjustedProducts = products.map(product => {
//     //         const priceInVendorCurrency = product.product.purchase_price;
//     //         const priceInUSD = vendorCurrency === 'USD' ? priceInVendorCurrency / 3.67 : priceInVendorCurrency;
//     //         const quantity = product.quantity || 1;
//     //         const base_amount = priceInUSD * quantity;
//     //         const vat_amount = vendorCurrency === 'USD' ? 0 : (base_amount * (vatRate / 100));

//     //         return {
//     //             ...product,
//     //             priceInVendorCurrency,
//     //             priceInUSD,
//     //             base_amount,
//     //             vat_amount,
//     //             subtotal: base_amount + vat_amount
//     //         };
//     //     });

//     //     // Only filter for new POs, not for editing
//     //     if (!poId) {
//     //         const filteredProducts = adjustedProducts.filter(product =>
//     //             product.itemable_id === quotationId && product.product.vendor_id === selectedVendorId
//     //         );
//     //         setSelectedProducts(filteredProducts);
//     //     } else {
//     //         setSelectedProducts(adjustedProducts);
//     //     }
//     // }, [products, quotationId, selectedVendorId, vendorCurrency, vatRate, poId, purchaseorderData]);


//     // FIXED: Load products for both create and edit modes
//     // useEffect(() => {
//     //     // For editing existing PO, use the products from purchaseorderData
//     //     if (poId && purchaseorderData && purchaseorderData.product_item_details) {
//     //         console.log('Editing PO - Loading product_item_details:', purchaseorderData.product_item_details);

//     //         const adjustedProducts = purchaseorderData.product_item_details.map(product => {
//     //             const price = parseFloat(product.price) || 0;
//     //             const quantity = product.quantity || 1;
//     //             const base_amount = price * quantity;
//     //             const vat_amount = vendorCurrency === 'USD' ? 0 : (base_amount * (vatRate / 100));

//     //             return {
//     //                 ...product,
//     //                 id: product.id, // Make sure we have the product_item_detail ID
//     //                 priceInUSD: price,
//     //                 base_amount,
//     //                 vat_amount,
//     //                 subtotal: base_amount + vat_amount
//     //             };
//     //         });


//     //         console.log('Adjusted products for edit:', adjustedProducts);
//     //         setSelectedProducts(adjustedProducts);
//     //         return;
//     //     }


//     //     // For creating new PO from quotation products
//     //     if (!poId && products && products.length > 0) {
//     //         console.log('Creating new PO - Loading quotation products:', products);

//     //         const adjustedProducts = products.map(product => {
//     //             const priceInVendorCurrency = product.product.purchase_price;
//     //             const priceInUSD = vendorCurrency === 'USD' ? priceInVendorCurrency / 3.67 : priceInVendorCurrency;
//     //             const quantity = product.quantity || 1;
//     //             const base_amount = priceInUSD * quantity;
//     //             const vat_amount = vendorCurrency === 'USD' ? 0 : (base_amount * (vatRate / 100));

//     //             return {
//     //                 ...product,
//     //                 priceInVendorCurrency,
//     //                 priceInUSD,
//     //                 base_amount,
//     //                 vat_amount,
//     //                 subtotal: base_amount + vat_amount
//     //             };
//     //         });

//     //         // Filter products based on vendor and quotation
//     //         const filteredProducts = adjustedProducts.filter(product =>
//     //             product.itemable_id === quotationId && product.product.vendor_id === selectedVendorId
//     //         );


//     //         console.log('Filtered products for new PO:', filteredProducts);
//     //         setSelectedProducts(filteredProducts);
//     //     }
//     // }, [products, quotationId, selectedVendorId, vendorCurrency, vatRate, poId, purchaseorderData]);
//     // Calculate total amounts

//     useEffect(() => {
//     // For editing existing PO, use the products from purchaseorderData
//     if (poId && purchaseorderData && purchaseorderData.product_item_details) {
//         console.log('Editing PO - Loading product_item_details:', purchaseorderData.product_item_details);

//         const adjustedProducts = purchaseorderData.product_item_details.map(product => {
//             const price = parseFloat(product.price) || 0;
//             const quantity = product.quantity || 1;
//             const base_amount = price * quantity;

//             // Check if this is a custom product (from expense or manual entry)
//             const isCustomProduct = product.productable_type === 'custom' || 
//                                    product.productable_type === 'App\\Models\\ProjectExpense' ||
//                                    product.product_id === 0;

//             // Calculate VAT (custom products might have different VAT logic)
//             let vat_amount = 0;
//             if (isCustomProduct) {
//                 // For custom products, use existing VAT or calculate based on currency
//                 vat_amount = product.tax || (vendorCurrency === 'USD' ? 0 : (base_amount * (vatRate / 100)));
//             } else {
//                 vat_amount = vendorCurrency === 'USD' ? 0 : (base_amount * (vatRate / 100));
//             }

//             return {
//                 ...product,
//                 id: product.id,
//                 priceInUSD: price,
//                 base_amount,
//                 vat_amount: product.vat_amount || vat_amount,
//                 subtotal: product.subtotal || (base_amount + vat_amount),
//                 isCustom: isCustomProduct
//             };
//         });

//         console.log('Adjusted products for edit:', adjustedProducts);
//         setSelectedProducts(adjustedProducts);

//         // For PO list page, also populate manual items for custom products
//         if (isPOListPage) {
//             const customProducts = adjustedProducts.filter(product => 
//                 product.productable_type === 'custom' || 
//                 product.productable_type === 'App\\Models\\ProjectExpense' ||
//                 product.product_id === 0
//             );

//             if (customProducts.length > 0) {
//                 const manualItemsData = customProducts.map(product => ({
//                     item_name: product.item_name || "",
//                     item_description: product.item_description || "",
//                     quantity: product.quantity || 1,
//                     price: product.price || 0,
//                     tax: product.tax || 0,
//                     base_amount: product.base_amount || 0,
//                     vat_amount: product.vat_amount || 0,
//                     subtotal: product.subtotal || 0
//                 }));
//                 setManualItems(manualItemsData);
//             }
//         }
//         return;
//     }

//     // For creating new PO from quotation products
//     if (!poId && products && products.length > 0) {
//         console.log('Creating new PO - Loading quotation products:', products);

//         const adjustedProducts = products.map(product => {
//             const priceInVendorCurrency = product.product?.purchase_price || 0;
//             const priceInUSD = vendorCurrency === 'USD' ? priceInVendorCurrency / 3.67 : priceInVendorCurrency;
//             const quantity = product.quantity || 1;
//             const base_amount = priceInUSD * quantity;
//             const vat_amount = vendorCurrency === 'USD' ? 0 : (base_amount * (vatRate / 100));

//             return {
//                 ...product,
//                 priceInVendorCurrency,
//                 priceInUSD,
//                 base_amount,
//                 vat_amount,
//                 subtotal: base_amount + vat_amount,
//                 isCustom: false
//             };
//         });

//         // Filter products based on vendor and quotation
//         const filteredProducts = adjustedProducts.filter(product => {
//             // If no quotationId (creating PO manually), show all products for selected vendor
//             if (!quotationId) {
//                 return product.product?.vendor_id === selectedVendorId;
//             }
//             // If quotationId exists, filter by both vendor and quotation
//             return product.itemable_id === quotationId && product.product?.vendor_id === selectedVendorId;
//         });

//         console.log('Filtered products for new PO:', filteredProducts);
//         setSelectedProducts(filteredProducts);
//         return;
//     }

//     // For creating manual PO (no products from quotation) OR expense PO
//     if (!poId && (!products || products.length === 0)) {
//         console.log('Creating manual PO or expense PO - Starting with empty');

//         // Check if this might be an expense PO by checking passed data
//         if (purchaseorderData?.amount && !purchaseorderData?.product_item_details) {
//             // This is likely an expense PO
//             setSelectedProducts([]);
//             if (isPOListPage) {
//                 // Create a manual item for the expense
//                 setManualItems([{
//                     item_name: "Expense Payment",
//                     item_description: purchaseorderData.notes || "Expense payment",
//                     quantity: 1,
//                     price: purchaseorderData.base_amount || purchaseorderData.amount,
//                     tax: purchaseorderData.total_vat || 0,
//                     base_amount: purchaseorderData.base_amount || purchaseorderData.amount,
//                     vat_amount: purchaseorderData.total_vat || 0,
//                     subtotal: purchaseorderData.amount || 0
//                 }]);
//             }
//         } else {
//             // Regular manual PO creation
//             setSelectedProducts([]);
//         }
//     }
// }, [products, quotationId, selectedVendorId, vendorCurrency, vatRate, poId, purchaseorderData, isPOListPage]);


//     useEffect(() => {
//         const productsBaseTotal = selectedProducts.reduce((acc, product) => acc + product.base_amount, 0);
//         const productsVatTotal = selectedProducts.reduce((acc, product) => acc + product.vat_amount, 0);

//         const manualTotals = isPOListPage ? calculateManualItemsTotals() : { baseTotal: 0, vatTotal: 0 };

//         const totalBase = productsBaseTotal + manualTotals.baseTotal;
//         const totalVat = productsVatTotal + manualTotals.vatTotal;

//         setTotalBaseAmount(totalBase);
//         setTotalVatAmount(totalVat);
//     }, [selectedProducts, manualItems, isPOListPage]);

//     // Calculate discounted amount
//     const calculateDiscountedTotal = () => {
//         const { discount_type, discount_amount } = formData;
//         let discountedBase = totalBaseAmount;

//         if (discount_type === 'amount') {
//             discountedBase -= parseFloat(discount_amount || 0);
//         } else if (discount_type === 'percentage') {
//             const discountValue = (parseFloat(discount_amount || 0) / 100) * totalBaseAmount;
//             discountedBase -= discountValue;
//         }

//         return Math.max(0, discountedBase);
//     };

//     // Update amounts when dependencies change
//     useEffect(() => {
//         const discountedBase = calculateDiscountedTotal();
//         setDiscountedAmount(discountedBase);
//         const discountedVat = vendorCurrency === 'AED' ? (discountedBase * vatRate) / 100 : 0;
//         setFinalAmount(discountedBase + discountedVat);
//     }, [formData.discount_amount, formData.discount_type, totalBaseAmount, vendorCurrency, vatRate]);

//     // Automatically set due date = 30 days before end_date
//     useEffect(() => {
//         if (formData.end_date) {
//             const endDate = new Date(formData.end_date);
//             const dueDate = new Date(endDate);
//             dueDate.setDate(endDate.getDate() - 30);
//             const formattedDueDate = dueDate.toISOString().split("T")[0];
//             setFormData((prev) => ({
//                 ...prev,
//                 due_date: formattedDueDate,
//             }));
//         }
//     }, [formData.end_date]);

//     const fetchTermsDetails = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/quotationterm`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`, 'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,
//             });

//             const termDetails = response.data.quotation_terms.data.filter(term => term.type === 'purchase_order');

//             if (termDetails.length > 0) {
//                 let notes = termDetails[0]?.value || '';
//                 if (vendorCurrency) {
//                     notes = notes.replace(/{{currency}}/g, vendorCurrency);
//                 }
//                 setFormData((prevState) => ({
//                     ...prevState,
//                     notes: notes,
//                 }));
//             }
//         } catch (error) {
//             console.error('Error fetching quotation terms:', error);
//         }
//     };

//     useEffect(() => {
//         if (showModal && !poId) {
//             fetchTermsDetails();
//         } else if (showModal && poId && purchaseorderData) {
//             setFormData({
//                 ...purchaseorderData,
//                 notes: purchaseorderData.notes || formData.notes,
//             });
//             setSelectedVendorId(purchaseorderData.vendor_id || vendorId);
//         }
//     }, [showModal, poId, purchaseorderData, vendors, vendorId]);

//     const handleEditorChange = (value) => {
//         setFormData({
//             ...formData,
//             notes: value,
//         });
//     };

//     // useEffect(() => {
//     //     if (poId && purchaseorderData) {
//     //         const subscription = purchaseorderData.vendor_subscriptions?.[0] || {};
//     //         setFormData({
//     //             project_id: purchaseorderData.project_id || '',
//     //             quotation_id: purchaseorderData.quotation_id || '',
//     //             vendor_id: purchaseorderData.vendor_id || '',
//     //             ref_no: purchaseorderData.ref_no || '',
//     //             date: purchaseorderData.date || '',
//     //             valid_till_date: purchaseorderData.valid_till_date || '',
//     //             document: purchaseorderData.document || '',
//     //             discount_amount: purchaseorderData.discount_amount || '',
//     //             discount_type: purchaseorderData.discount_type || 'amount',
//     //             serial_no: purchaseorderData.serial_no || '',
//     //             amount: purchaseorderData.amount || '',
//     //             notes: purchaseorderData.notes || '',
//     //             purchase_type: purchaseorderData.purchase_type || '',
//     //             payment_term: subscription.payment_term || '',
//     //             start_date: subscription.start_date || '',
//     //             end_date: subscription.end_date || '',
//     //             due_date: JSON.parse(subscription.due_dates || '[]')[0]?.date || '',
//     //         });

//     //         setSelectedVendorId(purchaseorderData.vendor_id || vendorId);
//     //     } else {
//     //         const currentDate = new Date().toISOString().split('T')[0];
//     //         setFormData({
//     //             project_id: projectId,
//     //             quotation_id: quotationId,
//     //             vendor_id: selectedVendorId,
//     //             ref_no: '',
//     //             date: currentDate,
//     //             valid_till_date: '',
//     //             document: '',
//     //             discount_amount: '',
//     //             discount_type: 'amount',
//     //             serial_no: '',
//     //             amount: '',
//     //         });
//     //     }
//     // }, [poId, purchaseorderData, vendorId, quotationId, projectId, selectedVendorId, vatRate]);

//   useEffect(() => {
//     if (poId && purchaseorderData) {
//         const subscription = purchaseorderData.vendor_subscriptions?.[0] || {};

//         // Calculate initial totals from product_item_details
//         let initialBaseAmount = 0;
//         let initialTotalVat = 0;
//         let initialFinalAmount = 0;

//         if (purchaseorderData.product_item_details && purchaseorderData.product_item_details.length > 0) {
//             initialBaseAmount = purchaseorderData.product_item_details.reduce((sum, item) => {
//                 return sum + (parseFloat(item.price) || 0) * (item.quantity || 1);
//             }, 0);

//             initialTotalVat = purchaseorderData.product_item_details.reduce((sum, item) => {
//                 return sum + (parseFloat(item.tax) || 0);
//             }, 0);

//             initialFinalAmount = purchaseorderData.product_item_details.reduce((sum, item) => {
//                 return sum + (parseFloat(item.subtotal) || 0);
//             }, 0);
//         }

//         setFormData({
//             project_id: purchaseorderData.project_id || '',
//             quotation_id: purchaseorderData.quotation_id || '',
//             vendor_id: purchaseorderData.vendor_id || '',
//             ref_no: purchaseorderData.ref_no || '',
//             date: purchaseorderData.date || '',
//             valid_till_date: purchaseorderData.valid_till_date || '',
//             document: purchaseorderData.document || '',
//             discount_amount: purchaseorderData.discount_amount || '',
//             discount_type: purchaseorderData.discount_type || 'amount',
//             serial_no: purchaseorderData.serial_no || '',
//             amount: purchaseorderData.amount || initialFinalAmount,
//             notes: purchaseorderData.notes || '',
//             purchase_type: purchaseorderData.purchase_type || '',
//             payment_term: subscription.payment_term || '',
//             start_date: subscription.start_date || '',
//             end_date: subscription.end_date || '',
//             due_date: JSON.parse(subscription.due_dates || '[]')[0]?.date || '',
//         });

//         setSelectedVendorId(purchaseorderData.vendor_id || vendorId);

//         // Also set the calculated totals
//         setTotalBaseAmount(purchaseorderData.base_amount || initialBaseAmount);
//         setTotalVatAmount(purchaseorderData.total_vat || initialTotalVat);
//         setFinalAmount(purchaseorderData.amount || initialFinalAmount);
//     } else {
//         const currentDate = new Date().toISOString().split('T')[0];
//         setFormData({
//             project_id: projectId,
//             quotation_id: quotationId,
//             vendor_id: selectedVendorId,
//             ref_no: '',
//             date: currentDate,
//             valid_till_date: '',
//             document: '',
//             discount_amount: '',
//             discount_type: 'amount',
//             serial_no: '',
//             amount: '',
//         });
//     }
// }, [poId, purchaseorderData, vendorId, quotationId, projectId, selectedVendorId, vatRate]);

//     useEffect(() => {
//         if (showModal) {
//             if (!poId) {
//                 const fetchRefNo = async () => {
//                     try {
//                         const backendUrl = process.env.REACT_APP_BACKEND_URL;
//                         const userInfo = JSON.parse(localStorage.getItem('user-info'));
//                         const origin = localStorage.getItem('user-origin');
//                         const token = userInfo?.token;

//                         const response = await axios.get(`${backendUrl}/api/purchaseorder/ref-no`, {
//                             headers: {
//                                 'Authorization': `Bearer ${token}`,
//                                 'Tenant-Origin': origin,
//                             },
//                             skipLoader: true,
//                             params: {
//                                 quotation_id: quotationId,
//                             }
//                         });

//                         setRefNo(response.data.ref_no);
//                         setFormData(prevData => ({
//                             ...prevData,
//                             ref_no: response.data.ref_no,
//                         }));
//                     } catch (error) {
//                         console.error('Error fetching ref_no:', error);
//                     }
//                 };
//                 fetchRefNo();
//             }
//         }
//     }, [showModal, quotationId, poId]);

//     const handleQuantityChange = (e, productId) => {
//         const newQuantity = parseInt(e.target.value, 10);
//         const updatedProducts = selectedProducts.map(product =>
//             product.id === productId ? {
//                 ...product,
//                 quantity: newQuantity,
//                 base_amount: newQuantity * product.priceInUSD,
//                 vat_amount: vendorCurrency === 'USD' ? 0 : (newQuantity * product.priceInUSD * (vatRate / 100)),
//                 subtotal: (newQuantity * product.priceInUSD) + (vendorCurrency === 'USD' ? 0 : (newQuantity * product.priceInUSD * (vatRate / 100)))
//             } : product
//         );
//         setSelectedProducts(updatedProducts);
//     };

//     const handleDeleteProduct = (productId) => {
//         const updatedProducts = selectedProducts.filter(product => product.id !== productId);
//         setSelectedProducts(updatedProducts);
//     };

//     const handleDeleteManualItem = (index) => {
//         if (manualItems.length > 1) {
//             const updated = manualItems.filter((_, i) => i !== index);
//             setManualItems(updated);
//         }
//     };

//     const addPO = async (newPO) => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.post(`${backendUrl}/api/purchase-order`, newPO, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Content-Type': 'multipart/form-data',
//                     'Tenant-Origin': origin,
//                 },
//             });

//             const createdPurchseorder = response.data.purchaseorder;
//             setPurchaseOrderDetails((prevPurchaseorder = []) => [...prevPurchaseorder, createdPurchseorder]);
//             // navigate(`/purchase-order/details/${createdPurchseorder.id}`);
//             handleClose();
//         } catch (error) {
//             console.error('Error adding quotation:', error);
//         }
//     };

//     const editPO = async (poId, updatedData) => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem("user-origin");
//             const token = userInfo?.token;

//             const response = await axios.post(
//                 `${backendUrl}/api/purchase-order/${poId}?_method=PUT`,
//                 updatedData,
//                 {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                         "Content-Type": "multipart/form-data",
//                         'Tenant-Origin': origin,
//                     },
//                 }
//             );

//             const updatedPO = response.data?.purchaseorder;

//             if (updatedPO) {
//                 console.log("Purchase Order updated successfully:", updatedPO);

//                 if (setPurchaseOrder) {
//                     setPurchaseOrder((prevPO) => ({
//                         ...prevPO,
//                         ...updatedPO,
//                         product_item_details: updatedPO.product_item_details.map((newItem, index) => {
//                             const existingItem = prevPO.product_item_details?.[index] || {};
//                             return {
//                                 ...existingItem,
//                                 ...newItem,
//                                 product: {
//                                     ...existingItem.product,
//                                     ...newItem.product,
//                                     vendor: {
//                                         ...existingItem.product?.vendor,
//                                         ...newItem.product?.vendor,
//                                     },
//                                 },
//                             };
//                         }),
//                     }));
//                 } else if (setPurchaseOrders) {
//                     setPurchaseOrders((prevOrders) => {
//                         const ordersArray = Array.isArray(prevOrders) ? prevOrders : [];
//                         return ordersArray.map((po) =>
//                             po.id === poId ? updatedPO : po
//                         );
//                     });
//                 }
//             } else {
//                 console.error("Update failed, no data returned from API.");
//             }

//             handleClose();
//         } catch (error) {
//             console.error("Error updating purchase order:", error);
//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'error',
//                 title: 'Failed to update the purchase order. Please try again.',
//                 timer: 3000,
//                 timerProgressBar: false,
//                 showConfirmButton: false,
//                 didOpen: () => {
//                     const container = Swal.getContainer();
//                     container.style.top = '50px';
//                 },
//             });
//         }
//     };

//     // FIXED: Proper data submission with base_amount
//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         // Prepare products data - use base_amount for the amount field
//         const productItems = selectedProducts.map(product => ({
//             product_id: product.product?.id,
//             quantity: product.quantity,
//             price: product.priceInUSD,
//             base_amount: product.base_amount, // This is the amount without VAT
//             vat_amount: product.vat_amount,
//             subtotal: product.subtotal, // This includes VAT
//             item_name: product.item_name,
//             item_description: product.item_description,
//         }));

//         // Add manual items if on PO list page
//         const manualProductItems = isPOListPage ? manualItems.map(item => ({
//             product_id: null,
//             quantity: item.quantity,
//             price: item.price,
//             tax: item.tax || 0, // Only send tax
//             subtotal: item.subtotal,
//             item_name: item.item_name,
//             item_description: item.item_description,
//             is_manual: true
//         })) : [];

//         const allProducts = [...productItems, ...manualProductItems];

//         const purchaseOrderData = {
//             ...formData,
//             vendor_id: selectedVendorId,
//             base_amount: totalBaseAmount, // Send TOTAL base_amount for the entire PO
//             amount: finalAmount, // Total amount with VAT
//             total_vat: totalVatAmount, // Send TOTAL VAT for the entire PO
//             vat_rate: vatRate,
//             vendor_currency: vendorCurrency,
//             vendorId: selectedVendorId,
//             quotationId,
//             products: allProducts,
//                ref_no: formData.ref_no, 
//         };

//         console.log('Purchase Order Data:', purchaseOrderData);

//         setLoading(true);

//         try {
//             let response;

//             if (poId) {
//                 response = await editPO(poId, purchaseOrderData);
//                 if (isQuotationParent) {
//                     fetchQuotations();
//                 }
//                 Swal.fire({
//                     toast: true,
//                     position: 'top-end',
//                     icon: 'success',
//                     title: 'Purchase order updated successfully.',
//                     timer: 3000,
//                     timerProgressBar: false,
//                     showConfirmButton: false,
//                     didOpen: () => {
//                         const container = Swal.getContainer();
//                         container.style.top = '50px';
//                     },
//                 });
//             } else {
//                 response = await addPO(purchaseOrderData);
//             }

//         } catch (error) {
//             console.error('Error submitting the form:', error);
//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'error',
//                 title: 'There was an error processing your request.',
//                 timer: 3000,
//                 timerProgressBar: false,
//                 showConfirmButton: false,
//                 didOpen: () => {
//                     const container = Swal.getContainer();
//                     container.style.top = '50px';
//                 },
//             });
//         } finally {
//             setLoading(false);
//             handleClose();
//         }
//     };


//     return (
//         <Offcanvas show={showModal} onHide={handleClose} placement='end' style={{ zIndex: 1050, width: '1000px' }}>
//             <Offcanvas.Header closeButton>
//                 <Offcanvas.Title>{poId ? 'Edit Purchase Order' : 'Create Purchase Order'}</Offcanvas.Title>
//             </Offcanvas.Header>
//             <hr style={{ margin: 0 }} /><br />

//             <Offcanvas.Body>
//                 <Form onSubmit={handleSubmit}>

//                     <Row className="mb-3">

//                         <Col md={6}>
//                             <Form.Group controlId="ref_no">
//                                 <Form.Label style={{ fontSize: "13px" }}>Reference Number</Form.Label>
//                                 <Form.Control
//                                     style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                     type="text"
//                                     name="ref_no"
//                                     value={formData.ref_no}
//                                     onChange={(e) => setFormData({ ...formData, ref_no: e.target.value })}


//                                 />
//                             </Form.Group>
//                         </Col>
//                         <Col md={6}>
//                             <Form.Group controlId="date">
//                                 <Form.Label style={{ fontSize: "13px" }}>Date</Form.Label>
//                                 <Form.Control
//                                     style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                     type="date"
//                                     name="date"
//                                     value={formData.date}
//                                     onChange={(e) => setFormData({ ...formData, date: e.target.value })}
//                                 />
//                             </Form.Group>
//                         </Col>
//                     </Row>


//                     <Row className="mb-3">

//                         <Col md={6}>
//                             <Form.Group controlId="valid_till_date">
//                                 <Form.Label style={{ fontSize: "13px" }}>Valid Till Date</Form.Label>
//                                 <Form.Control
//                                     style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                     type="date"
//                                     name="valid_till_date"
//                                     value={formData.valid_till_date}
//                                     onChange={(e) => setFormData({ ...formData, valid_till_date: e.target.value })}
//                                 />
//                             </Form.Group>
//                         </Col>
//                         <Col md={6}>
//                             <Form.Group controlId="document">
//                                 <Form.Label style={{ fontSize: "13px" }}>Document</Form.Label>
//                                 <Form.Control
//                                     style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                     type="file"
//                                     name="document"
//                                     onChange={(e) => setFormData({ ...formData, document: e.target.files[0] })}
//                                 />
//                             </Form.Group>
//                         </Col>
//                     </Row>

//                     <Row className="mb-3">

//                         <Col md={6}>
//                             <Form.Group controlId="discount_amount">
//                                 <Form.Label style={{ fontSize: "13px" }}>One Time Discount</Form.Label>
//                                 <Form.Control
//                                     style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                     type="text"
//                                     name="discount_amount"
//                                     value={formData.discount_amount}
//                                     onChange={(e) => setFormData({ ...formData, discount_amount: e.target.value })}
//                                 />
//                             </Form.Group>
//                         </Col>
//                         <Col md={6}>
//                             <Form.Group controlId="discount_type">
//                                 <Form.Label style={{ fontSize: "13px" }}>Discount Type</Form.Label>
//                                 <Form.Select
//                                     style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                     name="discount_type"
//                                     value={formData.discount_type}
//                                     onChange={(e) => setFormData({ ...formData, discount_type: e.target.value })}
//                                 >
//                                     <option value="amount">Amount</option>
//                                     <option value="percentage">Percentage</option>
//                                 </Form.Select>
//                             </Form.Group>
//                         </Col>
//                     </Row>

//                     <Row className="mb-3">

//                         <Col md={6}>
//                             <Form.Group>
//                                 <Form.Label style={{ fontSize: "13px" }}>Purchase Type</Form.Label>
//                                 <Form.Select
//                                     style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                     value={formData.purchase_type || ''}
//                                     onChange={(e) => setFormData({ ...formData, purchase_type: e.target.value })}
//                                 >
//                                     <option value="">-- Select --</option>
//                                     <option value="product">Product</option>
//                                     <option value="subscription">Subscription</option>
//                                 </Form.Select>
//                             </Form.Group>
//                         </Col>
//                         <Col md={6}>
//                             <Form.Group controlId="vendor_id">
//                                 <Form.Label style={{ fontSize: "13px" }}>Vendor</Form.Label>
//                                 <Form.Select
//                                     style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                     value={selectedVendorId}
//                                     onChange={(e) => setSelectedVendorId(e.target.value)}
//                                     required
//                                 >
//                                     <option value="">Select Vendor</option>
//                                     {vendors.map(vendor => (
//                                         <option key={vendor.id} value={vendor.id}>
//                                             {vendor.name || vendor.business_name || `Vendor ${vendor.id}`}
//                                             {vendor.currency ? ` (${vendor.currency})` : ''}
//                                         </option>
//                                     ))}
//                                 </Form.Select>
//                             </Form.Group>
//                         </Col>
//                     </Row>

//                     {formData.purchase_type === 'subscription' && (
//                         <>
//                             <Row className="mb-3">
//                                 <Col md={6}>
//                                     <Form.Group>
//                                         <Form.Label style={{ fontSize: "13px" }}>Payment Term</Form.Label>
//                                         <Form.Select
//                                             style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                             value={formData.payment_term || ''}
//                                             onChange={(e) => setFormData({ ...formData, payment_term: e.target.value })}
//                                         >
//                                             <option value="">-- Select Term --</option>
//                                             <option value="yearly">Yearly</option>
//                                             <option value="half-yearly">Half-Yearly</option>
//                                             <option value="quarterly">Quarterly</option>
//                                             <option value="custom">Manual</option>
//                                         </Form.Select>
//                                     </Form.Group>
//                                 </Col>
//                                 <Col md={6}>
//                                     <Form.Group>
//                                         <Form.Label style={{ fontSize: "13px" }}>Start Date</Form.Label>
//                                         <Form.Control
//                                             style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                             type="date"
//                                             value={formData.start_date || ''}
//                                             onChange={(e) => setFormData({ ...formData, start_date: e.target.value })}
//                                         />
//                                     </Form.Group>
//                                 </Col>
//                             </Row>
//                             <Row className="mb-3">
//                                 <Col md={6}>
//                                     <Form.Group>
//                                         <Form.Label style={{ fontSize: "13px" }}>End Date</Form.Label>
//                                         <Form.Control
//                                             style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                             type="date"
//                                             value={formData.end_date || ''}
//                                             onChange={(e) => setFormData({ ...formData, end_date: e.target.value })}
//                                         />
//                                     </Form.Group>
//                                 </Col>
//                                 <Col md={6}>
//                                     <Form.Group>
//                                         <Form.Label style={{ fontSize: "13px" }}>Due Date</Form.Label>
//                                         <Form.Control
//                                             style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                             type="date"
//                                             value={formData.due_date || ''}
//                                             onChange={(e) => setFormData({ ...formData, due_date: e.target.value })}
//                                         />
//                                     </Form.Group>
//                                 </Col>
//                             </Row>
//                         </>
//                     )}

//                     <br /><br />

//                     {!isPOListPage && (
//                         <div>
//                             <h6>Products</h6>
//                             <table className="table">
//                                 <thead>
//                                     <tr>
//                                         <th width="15%" scope="col">Product</th>
//                                         <th width="25%" scope="col">Description</th>
//                                         <th width="10%" scope="col">Rate</th>
//                                         <th width="8%" scope="col">Qty</th>
//                                         <th width="12%" scope="col">Amount</th>
//                                         <th width="10%" scope="col">VAT</th>
//                                         <th width="10%" scope="col">Subtotal</th>
//                                         <th width="10%" scope="col">Action</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {selectedProducts.map(product => (
//                                         <tr key={product.id}>
//                                             <td>{product.item_name}</td>
//                                             <td>{product.item_description}</td>
//                                             <td>{(Number(product.priceInUSD) && !isNaN(Number(product.priceInUSD)) ? Number(product.priceInUSD) : 0).toFixed(2)}</td>
//                                             <td>
//                                                 <input
//                                                     type="number"
//                                                     value={product.quantity}
//                                                     min="1"
//                                                     className='form-control'
//                                                     onChange={(e) => handleQuantityChange(e, product.id)}
//                                                 />
//                                             </td>
//                                             <td>{product.base_amount.toFixed(2)}</td>
//                                             <td>{product.vat_amount.toFixed(2)}</td>
//                                             <td>{product.subtotal.toFixed(2)}</td>
//                                             <td>
//                                                 <span
//                                                     style={{ cursor: 'pointer', color: 'grey' }}
//                                                     onClick={() => handleDeleteProduct(product.id)}
//                                                 >
//                                                     <i className="fa fa-trash"></i>
//                                                 </span>
//                                             </td>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </table>
//                         </div>
//                     )}

//                     {isPOListPage && (
//                         <>
//                             <br />
//                             <Table bordered>
//                                 <thead>
//                                     <tr>
//                                         <th>Name</th>
//                                         <th>Description</th>
//                                         <th>Qty</th>
//                                         <th>Price</th>
//                                         <th>Amount</th>
//                                         <th>VAT</th>
//                                         <th>Subtotal</th>
//                                         <th>Action</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {manualItems.map((item, i) => (
//                                         <tr key={i}>
//                                             <td>
//                                                 <Form.Control
//                                                     value={item.item_name}
//                                                     onChange={(e) => updateManualItem(i, "item_name", e.target.value)}
//                                                     placeholder="Item name"
//                                                 />
//                                             </td>
//                                             <td>
//                                                 <Form.Control
//                                                     value={item.item_description}
//                                                     onChange={(e) => updateManualItem(i, "item_description", e.target.value)}
//                                                     placeholder="Item description"
//                                                 />
//                                             </td>
//                                             <td>
//                                                 <Form.Control
//                                                     type="number"
//                                                     min="1"
//                                                     value={item.quantity}
//                                                     onChange={(e) => updateManualItem(i, "quantity", e.target.value)}
//                                                 />
//                                             </td>
//                                             <td>
//                                                 <Form.Control
//                                                     type="number"
//                                                     step="0.01"
//                                                     min="0"
//                                                     value={item.price}
//                                                     onChange={(e) => updateManualItem(i, "price", e.target.value)}
//                                                 />
//                                             </td>
//                                             <td>{item.base_amount.toFixed(2)}</td>
//                                             <td>{item.vat_amount.toFixed(2)}</td>
//                                             <td>{item.subtotal.toFixed(2)}</td>
//                                             <td>
//                                                 {manualItems.length > 1 && (
//                                                     <Button
//                                                         variant="outline-danger"
//                                                         size="sm"
//                                                         onClick={() => handleDeleteManualItem(i)}
//                                                     >
//                                                         <i className="fa fa-trash"></i>
//                                                     </Button>
//                                                 )}
//                                             </td>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </Table>

//                             <button
//                                 type="button"
//                                 className="btn btn-outline-black btn-sm"
//                                 onClick={addManualRow}
//                                 title="Add Manual Item"
//                             >
//                                 <i className="fa fa-plus"></i>
//                             </button>
//                         </>
//                     )}

//                     <br /><br />

//                     {/* Amount Calculation Section */}
//                     <Row className="mb-2">
//                         <Col md={9}></Col>
//                         <Col md={3}>
//                             <label className="font_13 theme_text f_w_500 mb-0">Subtotal (Excluding VAT)</label>
//                             <div className="primary_input grid_input calculated_total text-end">
//                                 <input
//                                     type="text"
//                                     className="form-control"
//                                     value={totalBaseAmount.toFixed(2)}
//                                     readOnly
//                                     name='base_amount'
//                                 />
//                             </div>
//                         </Col>
//                     </Row>

//                     {formData.discount_amount > 0 && (
//                         <Row className="mb-2">
//                             <Col md={9}></Col>
//                             <Col md={3}>
//                                 <label className="font_13 theme_text f_w_500 mb-0">
//                                     Discount ({formData.discount_type === 'percentage' ? `${formData.discount_amount}%` : ''})
//                                 </label>
//                                 <div className="primary_input grid_input calculated_total text-end">
//                                     <input
//                                         type="text"
//                                         className="form-control"
//                                         value={formData.discount_type === 'percentage'
//                                             ? ((totalBaseAmount * parseFloat(formData.discount_amount || 0)) / 100).toFixed(2)
//                                             : parseFloat(formData.discount_amount || 0).toFixed(2)}
//                                         readOnly
//                                     />
//                                 </div>
//                             </Col>
//                         </Row>
//                     )}
//                     {formData.discount_amount > 0 && (

//                         <Row className="mb-2">
//                             <Col md={9}></Col>
//                             <Col md={3}>
//                                 <label className="font_13 theme_text f_w_500 mb-0">Amount After Discount</label>
//                                 <div className="primary_input grid_input calculated_total text-end">
//                                     <input
//                                         type="text"
//                                         className="form-control"
//                                         value={discountedAmount.toFixed(2)}

//                                     />
//                                 </div>
//                             </Col>
//                         </Row>
//                     )}

//                     {vendorCurrency === 'AED' && vatRate > 0 && (
//                         <Row className="mb-2">
//                             <Col md={9}></Col>
//                             <Col md={3}>
//                                 <label className="font_13 theme_text f_w_500 mb-0">Total VAT ({vatRate}%)</label>
//                                 <div className="primary_input grid_input calculated_total text-end">
//                                     <input
//                                         type="text"
//                                         className="form-control"
//                                         value={totalVatAmount.toFixed(2)}
//                                         name='total_vat'
//                                     />
//                                 </div>
//                             </Col>
//                         </Row>
//                     )}

//                     <Row className="mb-3">
//                         <Col md={9}></Col>
//                         <Col md={3}>
//                             <label className="font_13 theme_text f_w_500 mb-0">Total Amount</label>
//                             <div className="primary_input grid_input calculated_total text-end">
//                                 <input
//                                     type="text"
//                                     className="form-control"
//                                     value={finalAmount.toFixed(2)}
//                                     name='amount'
//                                 />
//                             </div>
//                         </Col>
//                     </Row>

//                     <Row className="mb-3">
//                         <Col md={12}>
//                             <Form.Group controlId="notes">
//                                 <Form.Label style={{ fontSize: "13px" }}>Payment Terms</Form.Label>
//                                 <ReactQuill
//                                     value={formData.notes}
//                                     onChange={handleEditorChange}
//                                     theme="snow"
//                                 />
//                             </Form.Group>
//                         </Col>
//                     </Row>
//                 </Form>
//             </Offcanvas.Body>
//             <div className="p-3 d-flex justify-content-end border-top">
//                 <button type="button" className="btn btn-secondary me-2" onClick={handleClose}>
//                     Close
//                 </button>
//                 <button type="button" className="btn btn-primary" onClick={handleSubmit} disabled={loading}>
//                     {loading ? 'Saving...' : 'Save'}
//                 </button>
//             </div>
//         </Offcanvas>
//     );
// };

// export default PurchaseOrderForm;



import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, Offcanvas, Table } from 'react-bootstrap';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Swal from 'sweetalert2';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";

const PurchaseOrderForm = ({ showModal, vendorId, onUpdate, onSuccess, products, handleClose, fetchQuotations, isQuotationParent, setPurchaseOrder, setPurchaseOrders, projectId, vendors, poId, quotationId, purchaseorderData }) => {
    console.log('po:', purchaseorderData);
    console.log('vendorid:', vendors);
    const quotation_id = purchaseorderData ? purchaseorderData.quotation_id : '';
    const navigate = useNavigate();
    const location = useLocation();
    const isPOListPage = location.pathname === "/po-list";

    const [purchaseOrderDetails, setPurchaseOrderDetails] = useState([products || []]);
    const [refNo, setRefNo] = useState('');
    const [selectedVendorId, setSelectedVendorId] = useState(vendorId || '');
    const [vendorCurrency, setVendorCurrency] = useState('AED');
    const [vatRate, setVatRate] = useState(0);

    // Manual line items state - only for PO list page
    const [manualItems, setManualItems] = useState([
        { item_name: "", item_description: "", quantity: 1, price: 0, tax: 0, base_amount: 0, vat_amount: 0, subtotal: 0 }
    ]);

    const [formData, setFormData] = useState({
        project_id: projectId,
        quotation_id: quotationId,
        vendor_id: selectedVendorId,
        ref_no: '',
        date: '',
        valid_till_date: '',
        document: '',
        discount_amount: '',
        discount_type: 'amount',
        serial_no: '',
        amount: '',
        notes: '',
        purchase_type: '',
        payment_term: '',
        start_date: '',
        end_date: '',
        due_date: '',
        client_id: '',
        project_id: '',
    });

    const [selectedProducts, setSelectedProducts] = useState([]);
    const [totalBaseAmount, setTotalBaseAmount] = useState(0);
    const [discountedAmount, setDiscountedAmount] = useState(0);
    const [totalVatAmount, setTotalVatAmount] = useState(0);
    const [finalAmount, setFinalAmount] = useState(0);
    const [loading, setLoading] = useState(false);

    // Reset form when modal closes
    useEffect(() => {
        if (!showModal) {
            setSelectedVendorId(vendorId || '');
            setVendorCurrency('AED');
            setVatRate(0);
            setManualItems([
                { item_name: "", item_description: "", quantity: 1, price: 0, tax: 0, base_amount: 0, vat_amount: 0, subtotal: 0 }
            ]);
            setFormData({
                project_id: projectId,
                quotation_id: quotationId,
                vendor_id: vendorId || '',
                ref_no: '',
                date: new Date().toISOString().split('T')[0],
                valid_till_date: '',
                document: '',
                discount_amount: '',
                discount_type: 'amount',
                serial_no: '',
                amount: '',
                notes: '',
                purchase_type: '',
                payment_term: '',
                start_date: '',
                end_date: '',
                due_date: '',
                client_id: '',
                project_id: '',

            });
            setSelectedProducts([]);
            setTotalBaseAmount(0);
            setDiscountedAmount(0);
            setTotalVatAmount(0);
            setFinalAmount(0);
            setLoading(false);
            setClients([]);
            setProjects([]);
        }
    }, [showModal, projectId, quotationId, vendorId]);
    // Add these states to PurchaseOrderForm component
    const [clients, setClients] = useState([]);
    const [projects, setProjects] = useState([]);
    const [selectedClientId, setSelectedClientId] = useState('');

    // Add useEffect to fetch clients
    useEffect(() => {
        const fetchClients = async () => {
            try {
                const backendUrl = process.env.REACT_APP_BACKEND_URL;
                const userInfo = JSON.parse(localStorage.getItem('user-info'));
                const origin = localStorage.getItem('user-origin');
                const token = userInfo?.token;

                const response = await axios.get(`${backendUrl}/api/contacts?type=client&issales=false`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                    skipLoader: true,
                });
                setClients(response.data.Data || []);
            } catch (error) {
                console.error('Error fetching clients:', error);
            }
        };

        if (showModal) {
            fetchClients();
        }
    }, [showModal]);

    // Function to fetch projects for selected client
    const fetchProjectsForClient = async (clientId) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/projects?client_id=${clientId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });
            setProjects(response.data.Data || []);
        } catch (error) {
            console.error('Error fetching projects:', error);
            setProjects([]);
        }
    };

    // Handle client change
    const handleClientChange = (e) => {
        const clientId = e.target.value;
        setSelectedClientId(clientId);
        setFormData(prev => ({ ...prev, client_id: clientId, project_id: '' }));

        if (clientId) {
            fetchProjectsForClient(clientId);
        } else {
            setProjects([]);
        }
    };

    // Handle project change
    const handleProjectChange = (e) => {
        const projectId = e.target.value;
        setFormData(prev => ({ ...prev, project_id: projectId }));
    };

    // Update formData initialization to include client_id and project_id
    useEffect(() => {
        if (poId && purchaseorderData) {
            // For edit mode, set existing client and project
            const projectId = purchaseorderData.project_id || '';
            const clientId = purchaseorderData.client_id || '';

            setFormData(prev => ({
                ...prev,
                project_id: projectId,
                client_id: clientId
            }));

            // If client_id exists, fetch its projects
            if (clientId) {
                setSelectedClientId(clientId);
                fetchProjectsForClient(clientId);
            }
        }
    }, [poId, purchaseorderData]);

    // Update vendor currency and VAT when vendor changes
    // Update vendor currency and VAT when vendor changes - FIX THIS
    useEffect(() => {
        // Only update if we're not in edit mode OR if vendor actually changed
        if (selectedVendorId && vendors && Array.isArray(vendors)) {
            const selectedVendor = vendors.find(vendor => vendor.id == selectedVendorId);
            if (selectedVendor) {
                const currency = selectedVendor.currency || 'AED';
                setVendorCurrency(currency);
                const vat = currency === 'USD' ? 0 : 5;
                setVatRate(vat);

                // Only update formData vendor_id if not editing
                if (!poId) {
                    setFormData(prev => ({
                        ...prev,
                        vendor_id: selectedVendorId
                    }));
                }
            }
        }
    }, [selectedVendorId, vendors, poId]); // Added poId to dependencies

    // Calculate VAT for manual items
    const calculateItemVAT = (price, qty, taxRate = null) => {
        if (vendorCurrency === "USD") return 0;
        const tax = taxRate !== null ? taxRate : vatRate;
        return (price * qty) * (tax / 100);
    };

    // Calculate base amount (without VAT)
    const calculateBaseAmount = (price, qty) => {
        return price * qty;
    };

    // Update manual line item
    const updateManualItem = (index, field, value) => {
        const updated = [...manualItems];
        updated[index][field] = value;

        const price = parseFloat(updated[index].price) || 0;
        const qty = parseFloat(updated[index].quantity) || 1;
        const taxRate = parseFloat(updated[index].tax) || vatRate;

        updated[index].base_amount = calculateBaseAmount(price, qty);
        updated[index].vat_amount = calculateItemVAT(price, qty, taxRate);
        updated[index].subtotal = updated[index].base_amount + updated[index].vat_amount;

        setManualItems(updated);
    };

    // Add new manual line item
    const addManualRow = () => {
        setManualItems([
            ...manualItems,
            { item_name: "", item_description: "", quantity: 1, price: 0, tax: vatRate, base_amount: 0, vat_amount: 0, subtotal: 0 }
        ]);
    };

    // Calculate totals from manual items
    const calculateManualItemsTotals = () => {
        const baseTotal = manualItems.reduce((total, item) => {
            const baseAmount = Number(item.base_amount) || 0;
            return total + baseAmount;
        }, 0);

        const vatTotal = manualItems.reduce((total, item) => {
            const vatAmount = Number(item.vat_amount) || 0;
            return total + vatAmount;
        }, 0);

        return {
            baseTotal: Number(baseTotal) || 0,
            vatTotal: Number(vatTotal) || 0
        };
    };

    // Load products for both create and edit modes
    useEffect(() => {
        console.log('Loading products - poId:', poId, 'isPOListPage:', isPOListPage, 'purchaseorderData:', purchaseorderData);

        // For editing existing PO, use the products from purchaseorderData
        if (poId && purchaseorderData) {
            console.log('Editing PO - Loading product_item_details:', purchaseorderData.product_item_details || purchaseorderData.productItemDetails);

            // Use either product_item_details or productItemDetails (depending on data structure)
            const productDetails = purchaseorderData.product_item_details || purchaseorderData.productItemDetails || [];

            if (productDetails.length > 0) {
                console.log('Found product details:', productDetails);

                // Separate custom and regular products
                const regularProducts = [];
                const customProducts = [];

                productDetails.forEach(product => {
                    const price = parseFloat(product.price) || 0;
                    const quantity = product.quantity || 1;
                    const base_amount = price * quantity;

                    // Check if this is a custom product
                    const isCustomProduct = product.productable_type === 'custom' ||
                        product.productable_type === 'App\\Models\\ProjectExpense' ||
                        product.product_id === 0 ||
                        product.product_id === null;

                    // Calculate VAT
                    let vat_amount = 0;
                    if (isCustomProduct) {
                        const taxRate = product.tax || vatRate;
                        vat_amount = vendorCurrency === 'USD' ? 0 : (base_amount * (taxRate / 100));
                    } else {
                        vat_amount = vendorCurrency === 'USD' ? 0 : (base_amount * (vatRate / 100));
                    }

                    const subtotal = (product.subtotal && !isNaN(product.subtotal)) ? parseFloat(product.subtotal) : (base_amount + vat_amount);

                    const productData = {
                        ...product,
                        id: product.id,
                        priceInUSD: price,
                        base_amount,
                        vat_amount,
                        subtotal,
                        isCustom: isCustomProduct
                    };

                    if (isCustomProduct) {
                        customProducts.push(productData);
                    } else {
                        regularProducts.push(productData);
                    }
                });

                console.log('Regular products for edit:', regularProducts);
                console.log('Custom products for edit:', customProducts);

                // Set regular products
                setSelectedProducts(regularProducts);

                // Handle custom products based on page type
                if (isPOListPage) {
                    // For PO list page, show custom products in manual items table
                    if (customProducts.length > 0) {
                        const manualItemsData = customProducts.map(product => ({
                            item_name: product.item_name || "",
                            item_description: product.item_description || "",
                            quantity: product.quantity || 1,
                            price: product.price || 0,
                            tax: product.tax || vatRate,
                            base_amount: product.base_amount || 0,
                            vat_amount: product.vat_amount || 0,
                            subtotal: product.subtotal || 0
                        }));
                        console.log('Setting manual items for edit:', manualItemsData);
                        setManualItems(manualItemsData);
                    } else {
                        // Keep at least one empty manual item
                        setManualItems([
                            { item_name: "", item_description: "", quantity: 1, price: 0, tax: vatRate, base_amount: 0, vat_amount: 0, subtotal: 0 }
                        ]);
                    }
                } else {
                    // For non-PO list pages, show custom products in the regular products table
                    setSelectedProducts(prev => [...prev, ...customProducts]);
                }
            } else {
                console.log('No product details found');
                setSelectedProducts([]);
                if (isPOListPage) {
                    setManualItems([
                        { item_name: "", item_description: "", quantity: 1, price: 0, tax: vatRate, base_amount: 0, vat_amount: 0, subtotal: 0 }
                    ]);
                }
            }
            return;
        }

        // For creating new PO from quotation products
        if (!poId && products && products.length > 0) {
            console.log('Creating new PO - Loading quotation products:', products);

            const adjustedProducts = products.map(product => {
                const priceInVendorCurrency = product.product?.purchase_price || 0;
                const priceInUSD = vendorCurrency === 'USD' ? priceInVendorCurrency / 3.67 : priceInVendorCurrency;
                const quantity = product.quantity || 1;
                const base_amount = priceInUSD * quantity;
                const vat_amount = vendorCurrency === 'USD' ? 0 : (base_amount * (vatRate / 100));

                return {
                    ...product,
                    priceInVendorCurrency,
                    priceInUSD,
                    base_amount,
                    vat_amount,
                    subtotal: base_amount + vat_amount,
                    isCustom: false
                };
            });

            // Filter products based on vendor and quotation
            const filteredProducts = adjustedProducts.filter(product => {
                // If no quotationId (creating PO manually), show all products for selected vendor
                if (!quotationId) {
                    return product.product?.vendor_id === selectedVendorId;
                }
                // If quotationId exists, filter by both vendor and quotation
                return product.itemable_id === quotationId && product.product?.vendor_id === selectedVendorId;
            });

            console.log('Filtered products for new PO:', filteredProducts);
            setSelectedProducts(filteredProducts);
            return;
        }

        // For creating manual PO (no products from quotation) OR expense PO
        if (!poId && (!products || products.length === 0)) {
            console.log('Creating manual PO or expense PO - Starting with empty');

            // Check if this might be an expense PO by checking passed data
            if (purchaseorderData?.amount && !purchaseorderData?.product_item_details) {
                // This is likely an expense PO
                setSelectedProducts([]);
                if (isPOListPage) {
                    // Create a manual item for the expense
                    setManualItems([{
                        item_name: "Expense Payment",
                        item_description: purchaseorderData.notes || "Expense payment",
                        quantity: 1,
                        price: purchaseorderData.base_amount || purchaseorderData.amount,
                        tax: purchaseorderData.total_vat || vatRate,
                        base_amount: purchaseorderData.base_amount || purchaseorderData.amount,
                        vat_amount: purchaseorderData.total_vat || 0,
                        subtotal: purchaseorderData.amount || 0
                    }]);
                }
            } else {
                // Regular manual PO creation
                setSelectedProducts([]);
            }
        }
    }, [products, quotationId, selectedVendorId, vendorCurrency, vatRate, poId, purchaseorderData, isPOListPage]);

    // Calculate total amounts
    useEffect(() => {
        console.log('Calculating totals - selectedProducts:', selectedProducts.length, 'manualItems:', manualItems.length);

        // Safely calculate product totals
        const productsBaseTotal = selectedProducts.reduce((acc, product) => {
            const baseAmount = Number(product.base_amount) || 0;
            return acc + baseAmount;
        }, 0);

        const productsVatTotal = selectedProducts.reduce((acc, product) => {
            const vatAmount = Number(product.vat_amount) || 0;
            return acc + vatAmount;
        }, 0);

        // Calculate manual items totals
        const manualTotals = isPOListPage ? calculateManualItemsTotals() : { baseTotal: 0, vatTotal: 0 };

        const totalBase = productsBaseTotal + (Number(manualTotals.baseTotal) || 0);
        const totalVat = productsVatTotal + (Number(manualTotals.vatTotal) || 0);

        console.log('Calculated totals - Base:', totalBase, 'VAT:', totalVat, 'Manual:', manualTotals);

        // Ensure we set numbers, not strings
        setTotalBaseAmount(Number(totalBase) || 0);
        setTotalVatAmount(Number(totalVat) || 0);
    }, [selectedProducts, manualItems, isPOListPage]);

    // Calculate discounted amount
    const calculateDiscountedTotal = () => {
        const { discount_type, discount_amount } = formData;
        let discountedBase = Number(totalBaseAmount) || 0;

        if (discount_type === 'amount') {
            discountedBase -= parseFloat(discount_amount || 0);
        } else if (discount_type === 'percentage') {
            const discountValue = (parseFloat(discount_amount || 0) / 100) * discountedBase;
            discountedBase -= discountValue;
        }

        return Math.max(0, discountedBase);
    };

    // Update amounts when dependencies change
    useEffect(() => {
        const discountedBase = calculateDiscountedTotal();
        setDiscountedAmount(discountedBase);
        const discountedVat = vendorCurrency === 'AED' ? (discountedBase * vatRate) / 100 : 0;
        const final = discountedBase + (Number(totalVatAmount) || 0);
        setFinalAmount(final);

        // Also update formData.amount
        setFormData(prev => ({
            ...prev,
            amount: final
        }));
    }, [formData.discount_amount, formData.discount_type, totalBaseAmount, totalVatAmount, vendorCurrency, vatRate]);

    // Automatically set due date = 30 days before end_date
    useEffect(() => {
        if (formData.end_date) {
            const endDate = new Date(formData.end_date);
            const dueDate = new Date(endDate);
            dueDate.setDate(endDate.getDate() - 30);
            const formattedDueDate = dueDate.toISOString().split("T")[0];
            setFormData((prev) => ({
                ...prev,
                due_date: formattedDueDate,
            }));
        }
    }, [formData.end_date]);

    const fetchTermsDetails = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/quotationterm`, {
                headers: {
                    Authorization: `Bearer ${token}`, 'Tenant-Origin': origin,
                },
                skipLoader: true,
            });

            const termDetails = response.data.quotation_terms.data.filter(term => term.type === 'purchase_order');

            if (termDetails.length > 0) {
                let notes = termDetails[0]?.value || '';
                if (vendorCurrency) {
                    notes = notes.replace(/{{currency}}/g, vendorCurrency);
                }
                setFormData((prevState) => ({
                    ...prevState,
                    notes: notes,
                }));
            }
        } catch (error) {
            console.error('Error fetching quotation terms:', error);
        }
    };

    useEffect(() => {
        if (showModal && !poId) {
            fetchTermsDetails();
        } else if (showModal && poId && purchaseorderData) {
            setFormData({
                ...purchaseorderData,
                notes: purchaseorderData.notes || formData.notes,
            });
            setSelectedVendorId(purchaseorderData.vendor_id || vendorId);
        }
    }, [showModal, poId, purchaseorderData, vendors, vendorId]);

    const handleEditorChange = (value) => {
        setFormData({
            ...formData,
            notes: value,
        });
    };
    const commonInputStyle = {
        fontSize: "13px",
        maxWidth: "370px",
        borderRadius: "14px",
        height: "35px",
        border: "0.5px solid rgb(232, 233, 237)",
    };

    // In the useEffect that handles editing (around line 65-180), update this part:
    useEffect(() => {
        if (poId && purchaseorderData) {
            const subscription = purchaseorderData.vendor_subscriptions?.[0] || {};

            // Set selected vendor FIRST
            const vendorIdFromData = purchaseorderData.vendor_id || vendorId;
            setSelectedVendorId(vendorIdFromData);

            // Calculate initial totals from product_item_details
            let initialBaseAmount = 0;
            let initialTotalVat = 0;
            let initialFinalAmount = 0;

            // Check both possible property names
            const productDetails = purchaseorderData.product_item_details || purchaseorderData.productItemDetails;

            if (productDetails && productDetails.length > 0) {
                initialBaseAmount = productDetails.reduce((sum, item) => {
                    return sum + (parseFloat(item.price) || 0) * (item.quantity || 1);
                }, 0);

                initialTotalVat = productDetails.reduce((sum, item) => {
                    return sum + (parseFloat(item.tax) || 0);
                }, 0);

                initialFinalAmount = productDetails.reduce((sum, item) => {
                    return sum + (parseFloat(item.subtotal) || 0);
                }, 0);
            }

            // Update formData with vendor_id from purchaseorderData
            setFormData({
                project_id: purchaseorderData.project_id || '',
                quotation_id: purchaseorderData.quotation_id || '',
                vendor_id: vendorIdFromData, // Use the vendor from data
                ref_no: purchaseorderData.ref_no || '',
                date: purchaseorderData.date || '',
                valid_till_date: purchaseorderData.valid_till_date || '',
                document: purchaseorderData.document || '',
                discount_amount: purchaseorderData.discount_amount || '',
                discount_type: purchaseorderData.discount_type || 'amount',
                serial_no: purchaseorderData.serial_no || '',
                amount: purchaseorderData.amount || initialFinalAmount,
                notes: purchaseorderData.notes || '',
                purchase_type: purchaseorderData.purchase_type || '',
                payment_term: subscription.payment_term || '',
                start_date: subscription.start_date || '',
                end_date: subscription.end_date || '',
                due_date: JSON.parse(subscription.due_dates || '[]')[0]?.date || '',
                client_id: purchaseorderData.client_id || '',
                project_id: purchaseorderData.project_id || '',

            });

            // Also set the calculated totals - ensure they are numbers
            setTotalBaseAmount(Number(purchaseorderData.base_amount || initialBaseAmount) || 0);
            setTotalVatAmount(Number(purchaseorderData.total_vat || initialTotalVat) || 0);
            setFinalAmount(Number(purchaseorderData.amount || initialFinalAmount) || 0);
        } else {
            const currentDate = new Date().toISOString().split('T')[0];
            setFormData({
                project_id: projectId,
                quotation_id: quotationId,
                vendor_id: selectedVendorId, // Use the current selectedVendorId
                ref_no: '',
                date: currentDate,
                valid_till_date: '',
                document: '',
                discount_amount: '',
                discount_type: 'amount',
                serial_no: '',
                amount: '',
                notes: '',
                purchase_type: '',
                payment_term: '',
                start_date: '',
                end_date: '',
                due_date: '',
            });
        }
    }, [poId, purchaseorderData, vendorId, quotationId, projectId]);

    useEffect(() => {
        if (showModal) {
            if (!poId) {
                const fetchRefNo = async () => {
                    try {
                        const backendUrl = process.env.REACT_APP_BACKEND_URL;
                        const userInfo = JSON.parse(localStorage.getItem('user-info'));
                        const origin = localStorage.getItem('user-origin');
                        const token = userInfo?.token;

                        const response = await axios.get(`${backendUrl}/api/purchaseorder/ref-no`, {
                            headers: {
                                'Authorization': `Bearer ${token}`,
                                'Tenant-Origin': origin,
                            },
                            skipLoader: true,
                            params: {
                                quotation_id: quotationId,
                            }
                        });

                        setRefNo(response.data.ref_no);
                        setFormData(prevData => ({
                            ...prevData,
                            ref_no: response.data.ref_no,
                        }));
                    } catch (error) {
                        console.error('Error fetching ref_no:', error);
                    }
                };
                fetchRefNo();
            }
        }
    }, [showModal, quotationId, poId]);

    const handleQuantityChange = (e, productId) => {
        const newQuantity = parseInt(e.target.value, 10) || 1;
        const updatedProducts = selectedProducts.map(product =>
            product.id === productId ? {
                ...product,
                quantity: newQuantity,
                base_amount: newQuantity * (Number(product.priceInUSD) || 0),
                vat_amount: vendorCurrency === 'USD' ? 0 : (newQuantity * (Number(product.priceInUSD) || 0) * (vatRate / 100)),
                subtotal: (newQuantity * (Number(product.priceInUSD) || 0)) + (vendorCurrency === 'USD' ? 0 : (newQuantity * (Number(product.priceInUSD) || 0) * (vatRate / 100)))
            } : product
        );
        setSelectedProducts(updatedProducts);
    };

    const handleDeleteProduct = (productId) => {
        const updatedProducts = selectedProducts.filter(product => product.id !== productId);
        setSelectedProducts(updatedProducts);
    };

    const handleDeleteManualItem = (index) => {
        if (manualItems.length > 1) {
            const updated = manualItems.filter((_, i) => i !== index);
            setManualItems(updated);
        }
    };

    const addPO = async (newPO) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.post(`${backendUrl}/api/purchase-order`, newPO, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                    'Tenant-Origin': origin,
                },
            });

            const createdPurchseorder = response.data.purchaseorder;
            setPurchaseOrderDetails((prevPurchaseorder = []) => [...prevPurchaseorder, createdPurchseorder]);
            handleClose();
        } catch (error) {
            console.error('Error adding quotation:', error);
        }
    };

    const editPO = async (poId, updatedData) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem("user-origin");
            const token = userInfo?.token;

            const response = await axios.post(
                `${backendUrl}/api/purchase-order/${poId}?_method=PUT`,
                updatedData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                        'Tenant-Origin': origin,
                    },
                }
            );

            const updatedPO = response.data?.purchaseorder;

            if (updatedPO) {
                console.log("Purchase Order updated successfully:", updatedPO);

                if (setPurchaseOrder) {
                    setPurchaseOrder((prevPO) => ({
                        ...prevPO,
                        ...updatedPO,
                        product_item_details: updatedPO.product_item_details.map((newItem, index) => {
                            const existingItem = prevPO.product_item_details?.[index] || {};
                            return {
                                ...existingItem,
                                ...newItem,
                                product: {
                                    ...existingItem.product,
                                    ...newItem.product,
                                    vendor: {
                                        ...existingItem.product?.vendor,
                                        ...newItem.product?.vendor,
                                    },
                                },
                            };
                        }),
                    }));
                } else if (setPurchaseOrders) {
                    setPurchaseOrders((prevOrders) => {
                        const ordersArray = Array.isArray(prevOrders) ? prevOrders : [];
                        return ordersArray.map((po) =>
                            po.id === poId ? updatedPO : po
                        );
                    });
                }
            } else {
                console.error("Update failed, no data returned from API.");
            }

            handleClose();
        } catch (error) {
            console.error("Error updating purchase order:", error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Failed to update the purchase order. Please try again.',
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });
        }
    };

    // Proper data submission with base_amount
    const handleSubmit = async (e) => {
        e.preventDefault();

        console.log('Submitting form - selectedProducts:', selectedProducts.length, 'manualItems:', manualItems.length);

        // Prepare regular products data
        const regularProductItems = selectedProducts.map(product => ({
            product_id: product.product?.id,
            quantity: product.quantity,
            price: product.priceInUSD,
            base_amount: product.base_amount,
            vat_amount: product.vat_amount,
            subtotal: product.subtotal,
            item_name: product.item_name,
            item_description: product.item_description,
            productable_type: product.productable_type || 'App\\Models\\Product',
            productable_id: product.productable_id || product.product?.id,
            tax: product.tax || vatRate
        }));

        // Prepare custom products data
        let customProductItems = [];
        if (isPOListPage) {
            // For PO list page, custom products are in manualItems
            customProductItems = manualItems.filter(item => item.item_name || item.price > 0).map(item => ({
                product_id: null,
                quantity: item.quantity,
                price: item.price,
                tax: item.tax || vatRate,
                subtotal: item.subtotal,
                item_name: item.item_name,
                item_description: item.item_description,
                is_manual: true,
                productable_type: 'custom',
                productable_id: 0,
                base_amount: item.base_amount,
                vat_amount: item.vat_amount
            }));
        } else {
            // For non-PO list pages, custom products are in selectedProducts with isCustom flag
            const customProductsFromSelected = selectedProducts.filter(product => product.isCustom);
            customProductItems = customProductsFromSelected.map(product => ({
                product_id: null,
                quantity: product.quantity,
                price: product.price,
                tax: product.tax || vatRate,
                subtotal: product.subtotal,
                item_name: product.item_name,
                item_description: product.item_description,
                is_manual: true,
                productable_type: 'custom',
                productable_id: 0,
                base_amount: product.base_amount,
                vat_amount: product.vat_amount
            }));
        }

        const allProducts = [...regularProductItems, ...customProductItems];

        const purchaseOrderData = {
            ...formData,
            vendor_id: selectedVendorId,
            base_amount: totalBaseAmount,
            amount: finalAmount,
            used_amount: 0,
            total_vat: totalVatAmount,
            vat_rate: vatRate,
            vendor_currency: vendorCurrency,
            vendorId: selectedVendorId,
            quotationId,
            products: allProducts,
            ref_no: formData.ref_no,
        };

        console.log('Purchase Order Data:', purchaseOrderData);

        setLoading(true);

        try {
            if (poId) {
                await editPO(poId, purchaseOrderData);
                if (isQuotationParent) {
                    fetchQuotations();
                }
                if (onSuccess) {
                    onSuccess();
                }

                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'success',
                    title: 'Purchase order updated successfully.',
                    timer: 3000,
                    timerProgressBar: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        const container = Swal.getContainer();
                        container.style.top = '50px';
                    },
                });
            } else {
                if (onSuccess) {
                    onSuccess();
                }

                await addPO(purchaseOrderData);
            }

        } catch (error) {
            console.error('Error submitting the form:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'There was an error processing your request.',
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });
        } finally {
            setLoading(false);
            handleClose();

        }
    };

    // Debug effect to see state values
    useEffect(() => {
        console.log('State debug:', {
            totalBaseAmount,
            typeofTotalBaseAmount: typeof totalBaseAmount,
            totalVatAmount,
            discountedAmount,
            finalAmount,
            selectedProductsCount: selectedProducts.length,
            manualItemsCount: manualItems.length,
            manualItems: manualItems
        });
    }, [totalBaseAmount, totalVatAmount, discountedAmount, finalAmount, selectedProducts, manualItems]);

    return (
        <Offcanvas show={showModal} onHide={handleClose} placement='end' style={{ zIndex: 1050, width: '1000px' }}>
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>{poId ? 'Edit Purchase Order' : 'Create Purchase Order'}</Offcanvas.Title>
            </Offcanvas.Header>
            <hr style={{ margin: 0 }} /><br />

            <Offcanvas.Body>
                <Form onSubmit={handleSubmit}>

                    <Row className="mb-3">
                        <Col md={6}>
                            <Form.Group controlId="ref_no">
                                <Form.Label style={{ fontSize: "13px" }}>Reference Number</Form.Label>
                                <Form.Control
                                    style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    type="text"
                                    name="ref_no"
                                    value={formData.ref_no}
                                    onChange={(e) => setFormData({ ...formData, ref_no: e.target.value })}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="date">
                                <Form.Label style={{ fontSize: "13px" }}>
                                    Date
                                </Form.Label>

                                <div>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            format="DD-MM-YYYY"
                                            value={formData.date ? dayjs(formData.date) : null}
                                            onChange={(newValue) => {
                                                setFormData({
                                                    ...formData,
                                                    date: newValue
                                                        ? newValue.format("YYYY-MM-DD")
                                                        : "",
                                                });
                                            }}
                                            slotProps={{
                                                textField: {
                                                    variant: "standard",
                                                    InputProps: { disableUnderline: true },
                                                    sx: {
                                                        display: "block",
                                                        fontSize: "13px",
                                                        maxWidth: "370px",
                                                        borderRadius: "14px",
                                                        height: "35px",
                                                        border: "0.5px solid rgb(232, 233, 237)",
                                                        padding: "0 12px",
                                                    },
                                                },
                                                popper: { sx: { zIndex: 9999 } }, // Ensure calendar shows on top
                                            }}
                                        />
                                    </LocalizationProvider>
                                </div>
                            </Form.Group>
                        </Col>


                    </Row>

                    <Row className="mb-3">
                        <Col md={6}>
                            <Form.Group controlId="valid_till_date">
                                <Form.Label style={{ fontSize: "13px" }}>
                                    Valid Till Date
                                </Form.Label>

                                <div>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            format="DD-MM-YYYY"
                                            value={
                                                formData.valid_till_date
                                                    ? dayjs(formData.valid_till_date)
                                                    : null
                                            }
                                            onChange={(newValue) => {
                                                setFormData({
                                                    ...formData,
                                                    valid_till_date: newValue
                                                        ? newValue.format("YYYY-MM-DD")
                                                        : "",
                                                });
                                            }}
                                            slotProps={{
                                                textField: {
                                                    variant: "standard",
                                                    InputProps: { disableUnderline: true },
                                                    sx: {
                                                        display: "block",
                                                        fontSize: "13px",
                                                        maxWidth: "370px",
                                                        borderRadius: "14px",
                                                        height: "35px",
                                                        border: "0.5px solid rgb(232, 233, 237)",
                                                        padding: "0 12px",
                                                    },
                                                },
                                                popper: { sx: { zIndex: 9999 } },
                                            }}
                                        />
                                    </LocalizationProvider>
                                </div>
                            </Form.Group>
                        </Col>



                        <Col md={6}>
                            <Form.Group controlId="document">
                                <Form.Label style={{ fontSize: "13px" }}>Document</Form.Label>
                                <Form.Control
                                    style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    type="file"
                                    name="document"
                                    onChange={(e) => setFormData({ ...formData, document: e.target.files[0] })}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col md={6}>
                            <Form.Group controlId="discount_amount">
                                <Form.Label style={{ fontSize: "13px" }}>One Time Discount</Form.Label>
                                <Form.Control
                                    style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    type="text"
                                    name="discount_amount"
                                    value={formData.discount_amount}
                                    onChange={(e) => setFormData({ ...formData, discount_amount: e.target.value })}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="discount_type">
                                <Form.Label style={{ fontSize: "13px" }}>Discount Type</Form.Label>
                                <Form.Select
                                    style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    name="discount_type"
                                    value={formData.discount_type}
                                    onChange={(e) => setFormData({ ...formData, discount_type: e.target.value })}
                                >
                                    <option value="amount">Amount</option>
                                    <option value="percentage">Percentage</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label style={{ fontSize: "13px" }}>Purchase Type</Form.Label>
                                <Form.Select
                                    style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    value={formData.purchase_type || ''}
                                    onChange={(e) => setFormData({ ...formData, purchase_type: e.target.value })}
                                >
                                    <option value="">-- Select --</option>
                                    <option value="product">Product</option>
                                    <option value="subscription">Subscription</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="vendor_id">
                                <Form.Label style={{ fontSize: "13px" }}>Vendor</Form.Label>
                                <Form.Select
                                    style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    value={selectedVendorId}
                                    onChange={(e) => setSelectedVendorId(e.target.value)}
                                    required
                                >
                                    {/* <option value="">Select Vendor</option>
                                    {vendors.map(vendor => (
                                        <option key={vendor.id} value={vendor.id}>
                                            {vendor.name || vendor.business_name || `Vendor ${vendor.id}`}
                                            {vendor.currency ? ` (${vendor.currency})` : ''}
                                        </option>
                                    ))} */}
                                    <option value="">Select Vendor</option>
                                    {vendors && Array.isArray(vendors) && vendors.length > 0 ? (
                                        [...vendors]
                                            .sort((a, b) => (a.name || a.business_name || "").localeCompare(b.name || b.business_name || ""))
                                            .map(vendor => (
                                                <option key={vendor.id} value={vendor.id}>
                                                    {vendor.name || vendor.business_name || `Vendor ${vendor.id}`}
                                                    {vendor.currency ? ` (${vendor.currency})` : ''}
                                                </option>
                                            ))
                                    ) : (
                                        <option value="" disabled>No vendors available</option>
                                    )}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md={6}>
                            <Form.Group controlId="client_id">
                                <Form.Label style={{ fontSize: "13px" }}>Client</Form.Label>
                                <Form.Select
                                    style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    value={formData.client_id || ''}
                                    onChange={handleClientChange}
                                >
                                    <option value="">Select Client</option>
                                    {[...clients]
                                        .sort((a, b) => (a.name || a.business_name || "").localeCompare(b.name || b.business_name || ""))
                                        .map(client => (
                                            <option key={client.id} value={client.id}>
                                                {client.name || client.business_name || `Client ${client.id}`}
                                            </option>
                                        ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="project_id">
                                <Form.Label style={{ fontSize: "13px" }}>Project</Form.Label>
                                <Form.Select
                                    style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    value={formData.project_id || ''}
                                    onChange={handleProjectChange}
                                    disabled={!formData.client_id}
                                >
                                    <option value="">Select Project</option>
                                    {[...projects]
                                        .sort((a, b) => (a.name || "").localeCompare(b.name || ""))
                                        .map(project => (
                                            <option key={project.id} value={project.id}>
                                                {project.name}
                                                {project.is_client_based && ' (Client-Based)'}
                                            </option>
                                        ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>

                    {formData.purchase_type === 'subscription' && (
                        <>
                            <Row className="mb-3">
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label style={{ fontSize: "13px" }}>Payment Term</Form.Label>
                                        <Form.Select
                                            style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
                                            value={formData.payment_term || ''}
                                            onChange={(e) => setFormData({ ...formData, payment_term: e.target.value })}
                                        >
                                            <option value="">-- Select Term --</option>
                                            <option value="yearly">Yearly</option>
                                            <option value="half-yearly">Half-Yearly</option>
                                            <option value="quarterly">Quarterly</option>
                                            <option value="custom">Manual</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label style={{ fontSize: "13px" }}>Start Date</Form.Label>
                                        <Form.Control
                                            style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
                                            type="date"
                                            value={formData.start_date || ''}
                                            onChange={(e) => setFormData({ ...formData, start_date: e.target.value })}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label style={{ fontSize: "13px" }}>End Date</Form.Label>
                                        <Form.Control
                                            style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
                                            type="date"
                                            value={formData.end_date || ''}
                                            onChange={(e) => setFormData({ ...formData, end_date: e.target.value })}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label style={{ fontSize: "13px" }}>Due Date</Form.Label>
                                        <Form.Control
                                            style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
                                            type="date"
                                            value={formData.due_date || ''}
                                            onChange={(e) => setFormData({ ...formData, due_date: e.target.value })}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </>
                    )}

                    <br /><br />

                    {/* Show products table for non-PO list pages */}
                    {!isPOListPage && (
                        <div>
                            <h6>Products</h6>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th width="15%" scope="col">Product</th>
                                        <th width="25%" scope="col">Description</th>
                                        <th width="10%" scope="col">Rate</th>
                                        <th width="8%" scope="col">Qty</th>
                                        <th width="12%" scope="col">Amount({vendorCurrency})</th>
                                        <th width="10%" scope="col">VAT</th>
                                        <th width="10%" scope="col">Subtotal</th>
                                        <th width="10%" scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedProducts.length > 0 ? (
                                        selectedProducts.map(product => (
                                            <tr key={product.id}>
                                                <td>{product.item_name || 'N/A'}</td>
                                                <td>{product.item_description || ''}</td>
                                                <td>{(Number(product.priceInUSD) && !isNaN(Number(product.priceInUSD)) ? Number(product.priceInUSD) : 0).toFixed(2)}</td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        value={product.quantity || 1}
                                                        min="1"
                                                        onChange={(e) => handleQuantityChange(e, product.id)}
                                                    />
                                                </td>
                                                <td>{Number(product.base_amount || 0).toFixed(2)}</td>
                                                <td>{Number(product.vat_amount || 0).toFixed(2)}</td>
                                                <td>{Number(product.subtotal || 0).toFixed(2)}</td>
                                                <td>
                                                    <span
                                                        style={{ cursor: 'pointer', color: 'grey' }}
                                                        onClick={() => handleDeleteProduct(product.id)}
                                                    >
                                                        <i className="fa fa-trash"></i>
                                                    </span>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="8" className="text-center">
                                                No products found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {/* Show manual items table for PO list page */}
                    {isPOListPage && (
                        <>
                            <br />
                            <h6>Custom Products</h6>
                            <Table bordered>
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Description</th>
                                        <th>Qty</th>
                                        <th>Price</th>
                                        <th>Amount({vendorCurrency})</th>
                                        <th>VAT</th>
                                        <th>Subtotal</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {manualItems.length > 0 ? (
                                        manualItems.map((item, i) => (
                                            <tr key={i}>
                                                <td>
                                                    <Form.Control
                                                        value={item.item_name || ''}
                                                        onChange={(e) => updateManualItem(i, "item_name", e.target.value)}
                                                        placeholder="Item name"
                                                    />
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        value={item.item_description || ''}
                                                        onChange={(e) => updateManualItem(i, "item_description", e.target.value)}
                                                        placeholder="Item description"
                                                    />
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        type="number"
                                                        min="1"
                                                        value={item.quantity || 1}
                                                        className='form-control quantity-input'
                                                        onChange={(e) => updateManualItem(i, "quantity", e.target.value)}
                                                    />
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        type="number"
                                                        step="0.01"
                                                        min="0"
                                                        value={item.price || 0}
                                                        onChange={(e) => updateManualItem(i, "price", e.target.value)}
                                                    />
                                                </td>
                                                {/* <td>
                                                    <Form.Control
                                                        type="number"
                                                        step="0.01"
                                                        min="0"
                                                        max="100"
                                                        value={item.tax || vatRate}
                                                        onChange={(e) => updateManualItem(i, "tax", e.target.value)}
                                                    />
                                                </td> */}
                                                <td>{Number(item.base_amount || 0).toFixed(2)}</td>
                                                <td>{Number(item.vat_amount || 0).toFixed(2)}</td>
                                                <td>{Number(item.subtotal || 0).toFixed(2)}</td>
                                                <td>
                                                    {manualItems.length > 1 && (
                                                        <Button
                                                            variant="outline-danger"
                                                            size="sm"
                                                            onClick={() => handleDeleteManualItem(i)}
                                                        >
                                                            <i className="fa fa-trash"></i>
                                                        </Button>
                                                    )}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="9" className="text-center">
                                                No custom products added
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>

                            <button
                                type="button"
                                className="btn btn-outline-black btn-sm"
                                onClick={addManualRow}
                                title="Add Manual Item"
                            >
                                <i className="fa fa-plus"></i> Add Custom Product
                            </button>
                        </>
                    )}

                    <br /><br />

                    {/* Amount Calculation Section */}
                    <Row className="mb-2">
                        <Col md={9}></Col>
                        <Col md={3}>
                            <label className="font_13 theme_text f_w_500 mb-0">Subtotal (Excluding VAT)</label>
                            <div className="primary_input grid_input calculated_total text-end">
                                <input
                                    type="text"
                                    className="form-control"
                                    value={Number(totalBaseAmount || 0).toFixed(2)}
                                    readOnly
                                    name='base_amount'
                                />
                            </div>
                        </Col>
                    </Row>

                    {formData.discount_amount > 0 && (
                        <Row className="mb-2">
                            <Col md={9}></Col>
                            <Col md={3}>
                                <label className="font_13 theme_text f_w_500 mb-0">
                                    Discount ({formData.discount_type === 'percentage' ? `${formData.discount_amount}%` : ''})
                                </label>
                                <div className="primary_input grid_input calculated_total text-end">
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.discount_type === 'percentage'
                                            ? ((Number(totalBaseAmount || 0) * parseFloat(formData.discount_amount || 0)) / 100).toFixed(2)
                                            : parseFloat(formData.discount_amount || 0).toFixed(2)}
                                        readOnly
                                    />
                                </div>
                            </Col>
                        </Row>
                    )}
                    {formData.discount_amount > 0 && (
                        <Row className="mb-2">
                            <Col md={9}></Col>
                            <Col md={3}>
                                <label className="font_13 theme_text f_w_500 mb-0">Amount After Discount</label>
                                <div className="primary_input grid_input calculated_total text-end">
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={Number(discountedAmount || 0).toFixed(2)}
                                        readOnly
                                    />
                                </div>
                            </Col>
                        </Row>
                    )}

                    {(vendorCurrency === 'AED' || totalVatAmount > 0) && (
                        <Row className="mb-2">
                            <Col md={9}></Col>
                            <Col md={3}>
                                <label className="font_13 theme_text f_w_500 mb-0">Total VAT</label>
                                <div className="primary_input grid_input calculated_total text-end">
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={Number(totalVatAmount || 0).toFixed(2)}
                                        readOnly
                                        name='total_vat'
                                    />
                                </div>
                            </Col>
                        </Row>
                    )}

                    <Row className="mb-3">
                        <Col md={9}></Col>
                        <Col md={3}>
                            <label className="font_13 theme_text f_w_500 mb-0">Total Amount({vendorCurrency})</label>
                            <div className="primary_input grid_input calculated_total text-end">
                                <input
                                    type="text"
                                    className="form-control"
                                    value={Number(finalAmount || 0).toFixed(2)}
                                    readOnly
                                    name='amount'
                                />
                            </div>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col md={12}>
                            <Form.Group controlId="notes">
                                <Form.Label style={{ fontSize: "13px" }}>Payment Terms</Form.Label>
                                <ReactQuill
                                    value={formData.notes || ''}
                                    onChange={handleEditorChange}
                                    theme="snow"
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </Offcanvas.Body>
            <div className="p-3 d-flex justify-content-end border-top">
                <button type="button" className="btn btn-secondary me-2" onClick={handleClose}>
                    Close
                </button>
                <button type="button" className="btn btn-primary" onClick={handleSubmit} disabled={loading}>
                    {loading ? 'Saving...' : 'Save'}
                </button>
            </div>
        </Offcanvas>
    );
};

export default PurchaseOrderForm;
